import { devicesEsUs } from '@mangovoice/devices-ui'
import { extensionsEsUs } from '@mangovoice/extensions-ui'
import { hotelsEsUs } from '@mangovoice/hotels-ui'
import { messagingEsUs } from '@mangovoice/messaging-ui'
import { musicOnHoldEsUs } from '@mangovoice/music-on-hold-ui'
import { pbxLocationsEsUs } from '@mangovoice/pbx-locations-ui'
import { pbxSettingsEsUs } from '@mangovoice/pbx-settings-ui'
import { phoneNumbersEsUs } from '@mangovoice/phone-numbers-ui'
import { soundClipsEsUs } from '@mangovoice/soundclips-ui'
import { systemSettingsEsUs } from '@mangovoice/system-settings-ui'
import { userGroupsEsUs } from '@mangovoice/user-groups-ui'
import { webhooksEsUs } from '@mangovoice/webhooks-ui'

import { en } from './en'
import { scheduleEs } from './schedule.es'

export const es_us = {
  translation: {
    'Welcome to React': `Bienvenido a React y react-i18next`,
    yesterday: `Ayer`,
    today: `Hoy`,
    hour: `Hora`,
    day: `Día`,
    week: `Semana`,

    baseSettings: {
      profile: `Perfil`,
      snippets: `Fragmentos`,
      phone: `Teléfono`,
      fax: `Fax`,
      notifications: `Notificaciones`,
      audio: `Audio`,
      updates: `Actualizaciones`,
      blockedNumbers: `Números Bloqueados`,
      integrations: `Integraciones`,
      callCenter: `Centro de Llamadas`,
      experiments: `Experimentos`,
      shortcutKeys: `Teclas de Acceso Rápido`,
      collapse: `Contraer`,
      expand: `Expandir`,
      new: `Nuevo`,
      admin: `Administración`,
      closeAdmin: `Cerrar administración`,
      adminSections: `Secciones de administración`,
    },

    nav: {
      voicemail: `Correo de Voz`,
      calls: `Llamadas`,
      missedCalls: `Llamadas Perdidas`,
      text: `Mensajes de Texto`,
      messaging: `Mensajería`,
      fax: `Fax`,
      contacts: `Contactos`,
      settings: `Configuración`,
      webPhone: `Teléfono Web`,
      reporting: `Informes`,
      hotels: `Hoteles`,
      switchboard: `Cuadro de mandos`,
      devices: `Dispositivos`,
      extensions: `Extensiones`,
      messagingGroups: `Grupos de Mensajería`,
      soundClips: `Clips de Sonido`,
      musicOnHold: `Música en espera`,
      phoneNumbers: `Números de Teléfono`,
      locations: `Ubicaciones`,
      pbxSettings: `Configuración PBX`,
      schedules: `Horarios`,
      integrations: `Integraciones`,
      systemSettings: `Configuración del sistema`,
      users: `Usuarios`,
      userGroups: `Grupos de usuarios`,
      apiAccess: `Acceso API`,
      developers: `Desarrolladores`,
      mainNavigation: `Navegación principal`,
      skipToMainContent: `Saltar al contenido principal`,
      callAnalytics: `Análisis de llamadas`,
      status: `Estado`,
    },

    users: {
      detail: {
        close: `Cerrar detalles del usuario`,
        loadingUser: `Cargando usuario...`,
        pbxAssociations: {
          heading: `Asociaciones de PBX`,
          addToPbx: `Agregar a PBX`,
          filterPlaceholder: `Filtrar asociaciones de PBX...`,
          filterAriaLabel: `Filtrar asociaciones de PBX`,
          empty: `Este usuario no está asignado a ningún PBX.`,
          noMatches: `Ninguna asociación de PBX coincide con su búsqueda.`,
        },
      },
      generalInfo: {
        heading: `Información del usuario`,
        copyCognitoKey: `Copiar "Cognito Key"`,
        resetPassword: `Restablecer contraseña`,
        resetPasswordAria: `Restablecer contraseña`,
        editUserInformation: `Editar información del usuario`,
        deactivateUser: `Desactivar usuario`,
        activateUser: `Activar usuario`,
        username: `Nombre de usuario`,
        name: `Nombre`,
        role: `Rol`,
        email: `Correo electrónico`,
        lastLoggedIn: `Último inicio de sesión`,
        created: `Creado`,
        updated: `Actualizado`,
      },
      pbxAssociationCard: {
        editAria: `Editar asociación de {{pbxName}}`,
        removeAria: `Eliminar a {{userName}} de {{pbxName}}`,
        assignedExtensions: `Extensiones asignadas`,
        faxEmail: `Correo electrónico de fax`,
        faxNumber: `Número de fax`,
        pin: `PIN`,
        faxTitle: `Título de fax`,
      },
      phonePermissions: {
        heading: `Permisos telefónicos`,
        loading: `Cargando permisos telefónicos...`,
        empty: `Este usuario no está asignado a ningún grupo de permisos telefónicos.`,
        editAria: `Editar permisos telefónicos de {{pbxName}}`,
        noGroupsAssigned: `Sin grupos asignados.`,
      },
      pbxUserForm: {
        titleAdd: `Agregar a PBX`,
        titleEdit: `Editar asociación de PBX`,
        pbxLabel: `PBX`,
        pbxSearchPlaceholder: `Buscar PBX por nombre...`,
        pbxSearchAria: `Buscar opciones de PBX por nombre`,
        pbxSearching: `Buscando...`,
        pbxTypeToSearch: `Escriba para buscar PBX...`,
        pbxNoMatches: `Ningún PBX coincide con esa búsqueda.`,
        faxTitleLabel: `Título de fax`,
        faxTitlePlaceholder: `Título de fax`,
        sendingFaxEmailLabel: `Correo de envío de fax`,
        sendingFaxEmailPlaceholder: `Dirección de correo de fax`,
        invalidEmail: `Ingrese un correo electrónico válido.`,
        sendingFaxNumberLabel: `Número de envío de fax`,
        faxNumberSearchPlaceholder: `Buscar números de fax...`,
        faxNumberSelectPbxFirst: `Seleccione primero un PBX`,
        faxNumberSearchAria: `Buscar opciones de número de envío de fax`,
        faxNumbersLoading: `Cargando números de fax...`,
        faxNumbersEmpty: `No se encontraron números de fax para este PBX.`,
        pinLabel: `PIN`,
        pinPlaceholder: `PIN de 4 dígitos (1000-9999)`,
        userGroupsLabel: `Grupos de usuarios`,
        userGroupsSelected_one: `{{count}} seleccionado`,
        userGroupsSelected_other: `{{count}} seleccionados`,
        cancel: `Cancelar`,
        submitAdd: `Agregar a PBX`,
        submitEdit: `Guardar cambios`,
      },
      editPhonePermissions: {
        title: `Editar permisos telefónicos: {{userName}}`,
        pbxLabel: `PBX: {{pbxName}}`,
        groups: `Grupos`,
        noGroups: `No hay grupos disponibles para este PBX.`,
        required: `(obligatorio)`,
        selectedCount: `{{selected}} de {{total}} seleccionados`,
        close: `Cerrar`,
        submit: `Actualizar permisos telefónicos`,
      },
      formatAssignedAssets: {
        extension_one: `{{count}} extensión asignada`,
        extension_other: `{{count}} extensiones asignadas`,
        device_one: `{{count}} dispositivo asignado`,
        device_other: `{{count}} dispositivos asignados`,
        and: ` y `,
      },
      toast: {
        userCreated: {
          title: `Usuario creado`,
          description: `{{firstName}} {{lastName}} ha sido creado.`,
        },
        userCreateError: {
          title: `Error al crear el usuario`,
        },
        userUpdated: {
          title: `Usuario actualizado`,
        },
        userUpdateError: {
          title: `Error al actualizar el usuario`,
        },
        pbxAdded: {
          title: `Usuario agregado al PBX`,
        },
        pbxUpdated: {
          title: `Asociación de PBX actualizada`,
        },
        error: `Error`,
        associationRemoved: {
          title: `Asociación eliminada`,
          description: `{{name}} ha sido eliminado de este PBX.`,
        },
        alreadyRemoved: {
          title: `Ya eliminado`,
          description: `Este usuario no se encontró en el PBX y puede que ya haya sido eliminado.`,
        },
        removeFailed: `Error al eliminar el usuario del PBX.`,
        noPhonePermissionChanges: {
          title: `Sin cambios en permisos telefónicos`,
        },
        phonePermissionsUpdated: {
          title: `Permisos telefónicos actualizados`,
        },
        updateGroupFailed: `Error al actualizar "{{name}}".`,
        phonePermissionsUpdateError: {
          title: `Error al actualizar los permisos telefónicos`,
          fallback: `No se pueden actualizar los permisos telefónicos.`,
        },
        defaultUserName: `Usuario`,
      },
      removeDialog: {
        cannotTitle: `No se puede eliminar al usuario del PBX`,
        thisUserCapitalized: `Este usuario`,
        cannotBody: `<bold>{{userName}}</bold> tiene {{assets}} en este PBX. Reasigne o elimine estos activos antes de eliminar a este usuario del PBX.`,
        ok: `OK`,
        confirmTitle: `¿Eliminar usuario del PBX?`,
        thisUser: `este usuario`,
        confirmBody: `Esto eliminará a <bold>{{userName}}</bold> del PBX seleccionado.`,
        cancel: `Cancelar`,
        remove: `Eliminar`,
      },
      list: {
        title: `Usuarios`,
        searchPlaceholder: `Buscar por nombre, usuario o correo electrónico...`,
        searchAriaLabel: `Buscar usuarios`,
        newUser: `Nuevo usuario`,
        newUserAriaLabel: `Crear nuevo usuario`,
        newUserDisabledAriaLabel: `Crear nuevo usuario (deshabilitado)`,
        newUserPermissionTooltip: `No tienes permiso para crear usuarios`,
        clickToCopy: `Haz clic para copiar`,
        copied: `¡Copiado!`,
        loading: `Cargando usuarios...`,
        error: `Error`,
        emptyNoResultsTitle: `No se encontraron resultados`,
        emptyNoResultsDescription: `Intenta ajustar los términos de búsqueda`,
        emptyNoUsersTitle: `Aún no hay usuarios`,
        emptyNoUsersDescription: `Comienza creando tu primer usuario`,
        removeFromPbxTitle: `Eliminar {{name}} del PBX`,
        removeFromPbxDescription: `Si este usuario tiene dispositivos o extensiones asignados, se reasignarán al usuario seleccionado.`,
        reassignAndRemove: `Reasignar y eliminar`,
        cancel: `Cancelar`,
        reassignAssetsTo: `Reasignar recursos a`,
        selectUserPlaceholder: `Selecciona un usuario...`,
        searchingUsers: `Buscando...`,
        noMatchingUsers: `No hay usuarios coincidentes`,
        searchUsersToReassign: `Buscar usuarios para reasignar recursos`,
        candidateLoadFailed: `No se pudieron cargar los usuarios. Revisa tu conexión e inténtalo de nuevo.`,
        noOtherUsersOnPbx: `No hay otros usuarios en este PBX. Agrega otro usuario antes de eliminar este para que sus recursos puedan ser reasignados.`,
        defaultUserName: `Usuario`,
        column: {
          name: `Nombre`,
          usernameOrEmail: `Usuario / Correo electrónico`,
          role: `Rol`,
          faxEmail: `Correo para fax`,
          lastLogin: `Último acceso`,
          lastUpdated: `Última actualización`,
          action: `Acción`,
        },
        pagination: {
          resultsPerPage: `Resultados por página:`,
          previousPage: `Página anterior`,
          nextPage: `Página siguiente`,
          jumpToPage: `Ir a la página {{page}}`,
          all: `Todos`,
          recordRange: `{{start}}—{{end}} de {{total}}`,
          recordRangeEmpty: `0 de 0`,
        },
      },
      resetPassword: {
        toast: {
          copiedTitle: `Enlace de restablecimiento copiado al portapapeles`,
          copyFailedTitle: `Se generó el enlace de restablecimiento, pero no se pudo copiar`,
          manualCopyDescription: `Copia esta URL de restablecimiento manualmente: {{url}}`,
          missingUrlTitle: `No se pudo generar el enlace de restablecimiento`,
          missingUrlDescription: `No se devolvió ninguna URL de restablecimiento.`,
          requestFailedTitle: `Error al restablecer la contraseña`,
          unexpectedErrorDescription: `Ocurrió un error inesperado.`,
        },
      },
      create: {
        loadingForm: `Cargando el formulario de usuario...`,
      },
      edit: {
        loadingDetails: `Cargando los detalles del usuario...`,
        retryLoadingRoles: `Reintentar cargar roles`,
      },
      form: {
        heading: {
          newUser: `Nuevo usuario`,
          editUser: `Editar usuario`,
        },
        section: {
          pbxAssignment: `Asignación de PBX`,
        },
        field: {
          firstName: `Nombre`,
          lastName: `Apellido`,
          username: `Usuario`,
          usernameHelper: `Obligatorio. 4 a 150 caracteres. Solo letras, números, puntos o guiones. Nota: el nombre de usuario no se puede cambiar después de crearlo.`,
          email: `Correo electrónico`,
          emailHelper: `Opcional. El correo electrónico no se puede cambiar una vez establecido.`,
          isStaff: `¿Es personal de Mango?`,
          staffHelperIntro: `Esta designación otorga acceso completo al sistema con algunas excepciones:`,
          staffHelperBullet1: `El usuario no puede asignar la designación de Superusuario de Mango a otros usuarios.`,
          staffHelperBullet2: `El usuario no puede modificar a los Superusuarios de Mango.`,
          staffHelperBullet3: `El usuario no puede modificar servidores, proveedores ni fabricantes de dispositivos.`,
          isSuperuser: `Superusuario de Mango`,
          role: `Rol`,
          rolePlaceholder: `------`,
          roleUnavailable: `Opciones de rol no disponibles`,
          roleUnavailableHelper: `Las opciones de rol no están disponibles.`,
          roleWarning: `ADVERTENCIA: este rol se aplica a todos los PBX a los que pertenezca el usuario. Considera las implicaciones cuidadosamente antes de hacer cambios.`,
          pbx: `PBX`,
          pbxSearchPlaceholder: `Buscar PBX por nombre...`,
          pbxSearchAriaLabel: `Buscar opciones de PBX por nombre`,
          pin: `PIN`,
          pinPlaceholder: `PIN de 4 dígitos (1000-9999)`,
          faxTitle: `Título del fax`,
          faxTitlePlaceholder: `Título del fax`,
          sendingFaxEmail: `Correo para enviar fax`,
          sendingFaxEmailPlaceholder: `Dirección de correo para fax`,
          sendingFaxNumber: `Número para enviar fax`,
          searchFaxNumbers: `Buscar números de fax...`,
          selectPbxFirst: `Selecciona primero un PBX`,
          searchFaxNumbersAriaLabel: `Buscar opciones de número de fax de envío`,
          userGroups: `Grupos de usuarios`,
        },
        combobox: {
          searching: `Buscando...`,
          typeToSearchPbx: `Escribe para buscar PBX...`,
          noPbxMatches: `Ningún PBX coincide con esa búsqueda.`,
          loadingFaxNumbers: `Cargando números de fax...`,
          noFaxNumbers: `No se encontraron números de fax para este PBX.`,
        },
        userGroups: {
          placeholder: `Selecciona grupos de usuarios...`,
          searchPlaceholder: `Filtrar grupos de usuarios...`,
          emptyLabel: `No hay grupos de usuarios disponibles para este PBX.`,
          noResultsLabel: `Ningún grupo de usuarios coincide con tu filtro.`,
          summary_one: `{{count}} grupo seleccionado`,
          summary_other: `{{count}} grupos seleccionados`,
        },
        button: {
          cancel: `Cancelar`,
          saveAndCreateAnother: `Guardar y crear otro`,
          createUser: `Crear usuario`,
          saveChanges: `Guardar cambios`,
        },
      },
    },

    switchboard: {
      list: {
        title: `Cuadro de mandos`,
        subtitle: `Cree y gestione flujos de llamadas para su sistema de voz`,
        newSwitchboard: `Nuevo cuadro de mandos`,
        search: { placeholder: `Buscar por nombre...` },
        pagination: {
          resultsPerPage: `Resultados por página:`,
          previousPage: `Página anterior`,
          nextPage: `Página siguiente`,
          jumpToPage: `Ir a la página {{page}}`,
          all: `Todos`,
        },
        grid: {
          errorTitle: `Error`,
          errorLoading: `Error al cargar los cuadros de mandos:`,
          checkConsole: `Consulte la consola para más detalles`,
          loading: `Cargando cuadros de mandos...`,
        },
        empty: {
          noDataTitle: `Aún no hay cuadros de mandos`,
          noDataDescription: `Comience creando su primer cuadro de mandos`,
          noResultsTitle: `No hay cuadros de mandos en esta página`,
          noResultsDescription: `Pruebe a ajustar el tamaño de página o ir a otra página`,
          noSearchResultsTitle: `No se encontraron resultados`,
          noSearchResultsDescription: `Pruebe a ajustar los términos de búsqueda`,
        },
        card: {
          editAria: `Editar cuadro de mandos`,
          deleteAria: `Eliminar`,
          lastUpdated: `Última actualización`,
        },
        delete: {
          title: `Eliminar cuadro de mandos`,
          body: `¿Está seguro de que desea eliminar "{{displayName}}"? Esta acción no se puede deshacer.`,
          cancel: `Cancelar`,
          confirm: `Eliminar`,
        },
        deleteSuccessToast: `Cuadro de mandos eliminado`,
        deleteFailedToast: `Error al eliminar el cuadro de mandos`,
        edit: {
          title: `Editar cuadro de mandos`,
          nameLabel: `Nombre`,
          namePlaceholder: `p. ej., Cuadro de mandos - 7074`,
          numberLabel: `Número`,
          numberPlaceholder: `p. ej., 7074`,
          omitFromDirectoryLabel: `Omitir del directorio`,
          omitNo: `No`,
          omitYes: `Sí`,
          cancel: `Cancelar`,
          submit: `Actualizar cuadro de mandos`,
        },
      },
      edit: {
        loading: `Cargando cuadro de mandos...`,
        notFound: {
          title: `Cuadro de mandos no encontrado`,
          errorLoading: `Error al cargar el cuadro de mandos: {{message}}`,
          description: `El cuadro de mandos con extensión {{extensionDialPlan}} no existe en la API.`,
          thisCouldMean: `Esto podría significar:`,
          reasonDeleted: `El cuadro de mandos fue eliminado`,
          reasonNoData: `La extensión existe pero no tiene datos del cuadro de mandos`,
          reasonCorrupted: `Los datos están corruptos y no se pueden recuperar`,
          backToList: `← Volver a la lista de cuadros de mandos`,
          unknownError: `Error desconocido`,
        },
        save: {
          cannotSave: `No se puede guardar el cuadro de mandos`,
          success: `Cuadro de mandos guardado`,
          failed: `Error al guardar el cuadro de mandos`,
          requiredFieldError: `{{node}}: {{message}}`,
          unexpectedError: `Ocurrió un error inesperado.`,
          targetMismatch: `El cuadro de mandos cargado no coincide con esta página. Actualice antes de guardar.`,
        },
        header: {
          backToList: `Volver a los cuadros de mandos`,
          defaultName: `Cuadro de mandos {{extensionDialPlan}}`,
          deleteSwitchboard: `Eliminar cuadro de mandos`,
          save: `Guardar`,
          revertLocalChanges: `Revertir cambios locales`,
          refreshSwitchboard: `Actualizar cuadro de mandos`,
        },
        oldFormat: {
          warning: `⚠️ Advertencia: Los datos del cuadro de mandos están en formato antiguo`,
          description: `Este cuadro de mandos se creó con el editor antiguo. El flujo visual no se puede mostrar hasta que se migre al nuevo formato.`,
        },
        routeConflict: {
          title: `Conflicto de enrutamiento`,
          description: `{{node}} → {{route}} tiene varios destinos. Elimine uno antes de guardar.`,
        },
        unconfiguredSchedule: {
          description: `Un nodo de Programación en este flujo de llamadas no tiene una programación seleccionada. Seleccione una programación antes de guardar o desconecte el nodo.`,
          descriptionPlural: `{{count}} nodos de Programación en este flujo de llamadas no tienen una programación seleccionada. Seleccione una programación para cada uno antes de guardar o desconéctelos.`,
        },
        canvas: {
          emptyTitle: `Aún no hay flujo configurado`,
          emptyDescription: `Haga clic en "Añadir nodo" para empezar a crear su flujo de llamadas`,
          validationToastTitle: `¡Advertencia!`,
          invalidConnection: `Conexión no válida`,
        },
        unsavedChanges: {
          title: `Cambios sin guardar`,
          body: `Tiene cambios sin guardar. ¿Está seguro de que desea salir?`,
          stay: `Permanecer`,
          save: `Guardar`,
          leave: `Salir`,
        },
        revert: {
          title: `¿Revertir cambios locales?`,
          body: `Esto elimina los cambios hechos en esta sesión del navegador y recarga su último cuadro de mandos guardado. No eliminará lo que ya esté guardado.`,
          cancel: `Cancelar`,
          confirm: `Revertir cambios`,
          success: `Cambios locales revertidos`,
          successDescription: `Se restauró su último cuadro de mandos guardado.`,
        },
        versionConflict: {
          title: `Hay nuevas actualizaciones disponibles`,
          body: `Otra persona guardó cambios en este cuadro de mandos. Mantenga sus ediciones actuales o cargue la última versión guardada.`,
          keepWorking: `Mantener mis cambios`,
          loadLatest: `Cargar los cambios más recientes`,
        },
        refresh: {
          newerVersionTitle: `Cuadro de mandos actualizado`,
          newerVersionDescription: `Se detectó y cargó una versión guardada más reciente.`,
        },
        configPanel: {
          title: `Configurar {{type}}`,
          notImplemented: `La interfaz de configuración para este tipo de nodo aún no está implementada.`,
          cancel: `Cancelar`,
          save: `Guardar`,
        },
      },
      nodeLabels: {
        start: `INICIO`,
        transfer: `Transferir`,
        transfer_and_continue: `Transferir y continuar`,
        queue: `Cola`,
        auto_attendant: `Operador automático`,
        external_transfer: `Transferencia externa`,
        leave_voicemail: `Dejar correo de voz`,
        schedule: `Programación`,
        day_night: `Día/Noche`,
        dial_by_name: `Marcar por nombre`,
        sound_clip: `Clip de audio`,
        wait: `Esperar`,
        hang_up: `Colgar`,
        jump_to_switchboard: `Ir al cuadro de mandos`,
        conference_room: `Sala de conferencias`,
        transfer_and_rollover: `Transferir y pasar`,
        call_distribution: `Distribución de llamadas`,
        change_caller_id: `Cambiar ID de llamada`,
        webhook: `Webhook`,
        interactive_webhook: `Webhook interactivo`,
        fax_detect: `Detección de fax`,
        sms_notification: `Notificación SMS`,
        ai_agent_v1: `Agente IA`,
      },
      dialogs: {
        deleteNode: {
          title: `Eliminar nodo`,
          body: `¿Está seguro de que desea eliminar este nodo?`,
          bodyWithLabel: `¿Está seguro de que desea eliminar "{{label}}"?`,
          warning: `Esta acción no se puede deshacer. Todas las conexiones a este nodo también se eliminarán.`,
          cancel: `Cancelar`,
          confirm: `Eliminar`,
        },
        deleteEdge: {
          title: `Eliminar conexión`,
          body: `¿Está seguro de que desea eliminar esta conexión?`,
          warning: `Esta acción no se puede deshacer.`,
          cancel: `Cancelar`,
          confirm: `Eliminar`,
        },
        deleteSwitchboard: {
          title: `Eliminar cuadro de mandos`,
          body: `¿Está seguro de que desea eliminar este cuadro de mandos?`,
          bodyWithName: `¿Está seguro de que desea eliminar "{{name}}"?`,
          bodyWithId: `¿Está seguro de que desea eliminar el cuadro de mandos {{id}}?`,
          warning: `Esta acción no se puede deshacer. Toda la configuración y los datos del cuadro de mandos se eliminarán permanentemente.`,
          cancel: `Cancelar`,
          confirm: `Eliminar`,
        },
      },
      core: {
        selectExtension: `Seleccionar extensión...`,
        extensionLabel: `Extensión`,
        selectSchedule: `Seleccionar programación...`,
        scheduleLabel: `Programación`,
        selectSoundClip: `Seleccionar clip de audio...`,
        soundClipLabel: `Clip de audio`,
        selectSwitchboard: `Seleccionar cuadro de mandos...`,
        switchboardLabel: `Cuadro de mandos`,
        selectConferenceRoom: `Seleccionar sala de conferencias...`,
        conferenceRoomLabel: `Sala de conferencias`,
        selectQueue: `Seleccionar cola...`,
        queueLabel: `Cola`,
        selectFax: `Seleccionar extensión de fax...`,
        faxLabel: `Extensión de fax`,
        timeoutPlaceholder: `Tiempo de espera (segundos)`,
        timeoutIncrease: `Aumentar tiempo de espera`,
        timeoutDecrease: `Reducir tiempo de espera`,
        expand: `Expandir`,
        minimize: `Minimizar`,
        deleteNodeAria: `Eliminar nodo`,
        drop: `Soltar`,
        drag: `Arrastrar`,
        unnamed: `Sin nombre`,
        voicemailOptions: {
          definedByExtension: `Definido por extensión`,
          systemGenerated: `Saludo generado por el sistema`,
          noGreeting: `Sin saludo`,
          busy1: `Ocupado-1`,
          unavailable2: `No disponible-2`,
          custom3: `Personalizado-3`,
          custom4: `Personalizado-4`,
          custom5: `Personalizado-5`,
          custom6: `Personalizado-6`,
          custom7: `Personalizado-7`,
          custom8: `Personalizado-8`,
          custom9: `Personalizado-9`,
        },
      },
      create: {
        nameRequired: `Nombre requerido`,
        nameRequiredDescription: `Introduzca un nombre para este cuadro de mandos.`,
        invalidNumber: `Número no válido`,
        invalidNumberDescription: `Introduzca un número válido.`,
        invalidNumberRange: `El número debe ser 0 o entre 100 y 99999.`,
        pbxIdRequired: `ID de PBX requerido`,
        pbxIdRequiredDescription: `Se requiere el ID de PBX para crear un cuadro de mandos.`,
        createdSuccess: `Cuadro de mandos creado`,
        createFailed: `Error al crear el cuadro de mandos`,
        genericError: `Se produjo un error`,
        cannotAddSwitchboard: `No se puede añadir el cuadro de mandos '{{name}}'`,
        extensionAlreadyExists: `Ya existe una extensión con el número '{{number}}'.`,
        dialogTitle: `Nuevo cuadro de mandos`,
        close: `Cerrar`,
        submitButton: `Crear nuevo cuadro de mandos`,
      },
      nodes: {
        clickToConfigure: `Clic para configurar`,
        defaultLabel: `Nodo`,
        none: `Ninguno`,
        transfer: {
          extension: `Extensión`,
          extensionHelp: `Extensión a la que transferir la llamada`,
          timeout: `Tiempo de espera (segundos)`,
          timeoutHelp: `Tiempo de espera en segundos antes de continuar al siguiente nodo`,
          onInvalid: `Si es inválida`,
          onInvalidHelp: `Nodo al que ir si la extensión es inválida`,
          onTimeout: `Si hay tiempo de espera`,
          onTimeoutHelp: `Nodo al que ir si la transferencia hace tiempo de espera`,
        },
        wait: {
          duration: `Duración (segundos)`,
          selectDuration: `Seleccionar duración...`,
          ringDuringWait: `Sonar durante la espera`,
        },
        hangUp: {
          noConfig: `Este nodo termina la llamada. No requiere configuración.`,
          labelOptional: `Etiqueta`,
          labelPlaceholder: `Etiqueta para mostrar`,
        },
        smsNotification: {
          missedCall: `Llamada perdida`,
          custom: `Personalizado`,
          messageType: `Tipo de mensaje`,
          message: `Mensaje`,
          messagePlaceholder: `Llamada perdida de {CALLER_ID}-{CALLER_NUMBER}`,
          tooltipNotesTitle: `Notas`,
          tooltipNotesAria: `Información del mensaje SMS`,
          tooltip: {
            intro: `Cree su propio mensaje e incluya valores de Mango. Por ejemplo: una llamada entrante del 888-555-1212 con un ID de llamada de John Doe se introduciría como`,
            exampleTemplate: `Llamada perdida de {CALLER_ID}-{CALLER_NUMBER}`,
            exampleResultLeadIn: `Esto enviaría un mensaje SMS al destinatario SMS que aparecería así`,
            exampleResult: `Llamada perdida de John Doe-8885551212`,
            variablesHeading: `Variables`,
          },
          smsRecipient: `Destinatario SMS`,
          smsRecipientInfo: `Información del destinatario SMS`,
          separateNumbersHint: `Separe los números con coma para enviar a varios destinatarios`,
          or: `O`,
          autoReplyToCaller: `Responder automáticamente al llamante`,
          sendFrom: `Enviar desde`,
          selectSendFrom: `Seleccionar número...`,
          selectMessagingGroup: `Seleccionar grupo de mensajería...`,
          smsGroupLabel: `Grupo SMS:`,
          currentUnavailableNumber: `Valor actual (no disponible): {{value}}`,
          incomingCall: `Llamada entrante`,
          voicemail: `Correo de voz`,
        },
        queue: {
          onEscape: `Al escapar`,
          maxWait: `Espera máx.:`,
        },
        transferAndRollover: {
          noAnswer: `Sin respuesta`,
          busy: `Ocupado`,
        },
        common: {
          remove: `Eliminar`,
          addOption: `+ Añadir opción`,
          removeOption: `Eliminar opción`,
          tooltip: {
            variablesHeading: `Variables`,
            callerIdDesc: `El nombre de identificación del llamante de la persona que llama`,
            callerNumberDesc: `El número de la persona que llama`,
            numberDialedDesc: `El número que se marcó`,
            callUidDesc: `El id único de la llamada que puede usarse para buscar el registro de la llamada más adelante.`,
            dialedNumberNameDesc: `El nombre en mango del número al que se llama`,
            timeUtcDesc: `La hora de la llamada en la zona horaria UTC`,
          },
        },
        schedule: {
          open: `Abierto`,
          closed: `Cerrado`,
          holiday: `Festivo`,
        },
        aiAgent: {
          agentId: `ID de agente`,
          agentIdPlaceholder: `Introduzca UUID (36 caracteres)`,
          onError: `Si hay un error`,
          selectAgent: `Seleccionar agente...`,
          noAgents: `Sin agentes configurados`,
        },
        externalTransfer: {
          transferCompany: `Empresa de transferencia`,
          noCompany: `--`,
          searchTransferCompany: `Buscar empresas de transferencia...`,
          searchTransferCompanyAriaLabel: `Buscar empresas de transferencia`,
          noTransferCompanyMatches: `Ninguna empresa de transferencia coincide con su búsqueda.`,
          number: `Número`,
          enterPhoneNumber: `Introduzca número de teléfono`,
          phoneNumberExactDigitError: `El número de teléfono debe tener exactamente {{count}} dígitos`,
          phoneNumberDigitRangeError: `El número de teléfono debe tener entre {{min}} y {{max}} dígitos`,
          sipServer: `Servidor SIP`,
          enterSipServer: `Introduzca servidor SIP`,
          passThroughCallerId: `Pasar ID de llamada`,
          orUseThisCallerId: `O usar este ID de llamada`,
          selectCallerId: `Seleccionar ID de llamada...`,
          noPhoneNumbersAvailable: `No hay números de teléfono disponibles`,
          requireOneToConnect: `Requerir 1 para conectar`,
        },
        callDistribution: {
          weight: `Peso`,
          weightWarning: `¡Advertencia! El peso total en porcentaje debe ser 100. Ahora es {{total}}`,
        },
        changeCallerId: {
          callerId: `ID de llamada`,
          enterCallerId: `Introduzca ID de llamada`,
          addUpTo20Chars: `Añadir hasta 20 caracteres al principio`,
          replaceCallerId: `Reemplazar ID de llamada`,
        },
        dialByName: {
          invalid: `Inválido`,
          lookupBy: `Buscar por`,
          extensionName: `Nombre de extensión`,
          userName: `Nombre de usuario`,
          sortOrder: `Orden`,
          firstName: `Nombre`,
          lastName: `Apellido`,
          firstLastName: `Nombre/Apellido`,
        },
        leaveVoicemail: {
          message: `Mensaje`,
        },
        autoAttendant: {
          repeatTimes: `Veces de repetición`,
          allowExtensionDialing: `Permitir marcación por extensión`,
          press: `Pulsar`,
        },
        dayNight: {
          whenOpen: `Cuando esté abierto`,
          whenClosed: `Cuando esté cerrado`,
          open: `ABIERTO`,
          closed: `CERRADO`,
          pressToToggle: `(Pulsar {{code}} para alternar)`,
          basic: `Básico`,
          advanced: `Avanzado`,
          toggleCode: `Código de alternancia`,
          toastSuccess: `Estado día/noche del PBX actualizado correctamente`,
          toastFailed: `Error al actualizar el estado día/noche del PBX`,
        },
        webhook: {
          tooltipTitle: `¿Qué hacer?`,
          tooltipAria: `Información del webhook`,
          notifyUrl: `URL de notificación`,
          notifyUrlPlaceholder: `http://www.example.com/mango_notification.php`,
          tooltip: {
            intro: `Use esta función para enviar notificaciones a un sitio web o servidor externo`,
            exampleUsesHeading: `Ejemplos de uso:`,
            exampleUse1: `Notificación de pantalla emergente`,
            exampleUse2: `Registrar llamadas`,
            exampleUse3: `Provocar una acción en otro sitio`,
            exampleUse4: `Crear leads`,
            exampleUrlHeading: `URL de ejemplo`,
            curlyBracketsNote: `Las llaves serán reemplazadas por MangoVoice con datos reales.`,
          },
        },
        interactiveWebhook: {
          tooltipAria: `Información del webhook interactivo`,
          url: `URL`,
          urlPlaceholder: `http://www.example.com/webhook`,
          allowExtensionAsOption: `Permitir extensión como opción`,
          option: `Opción`,
          optionPlaceholder: `Opción`,
          tooltip: {
            intro: `Los webhooks interactivos permiten el enrutamiento en tiempo real entre Mango y su software.`,
            howItWorksHeading: `Cómo funciona:`,
            howItWorksBody: `Mango hará una solicitud GET a la url definida. Reemplazaremos todas las variables {} con los datos reales. Puede usar los parámetros en la solicitud para decidir cómo enrutar al llamante. Esto se hace enviando una respuesta con la opción a la que le gustaría que Mango enrute la llamada. Esto permite el enrutamiento en tiempo real de los llamantes.`,
            exampleCasesHeading: `Casos de ejemplo:`,
            exampleCase1: `Enrutamiento por habilidades`,
            exampleCase2: `Enrutar clientes de vuelta al agente que manejó la llamada inicial`,
            exampleCase3: `Personalizar la ruta de llamada para llamantes que vuelven.`,
            exampleRequestHeading: `Solicitud de ejemplo`,
            responseNote: `El valor de opción en la respuesta debe correlacionarse con las opciones establecidas en este objeto; también puede devolver un número de extensión.`,
            exampleResponseHeading: `Respuesta de ejemplo`,
            exampleResponseBody: `{"status": "success", "option": "1"}`,
          },
        },
      },
    },

    schedule: scheduleEs,

    global: {
      close: `Cerrar`,
      clearSearch: `Borrar búsqueda`,
      tooltip: {
        copyLink: `Copiar Enlace al Portapapeles`,
        copyLinkAt: `Copiar Enlace a las {{timeStamp}}`,
        copyLinkText: `Copiar Enlace`,
      },
      toast: {
        moveSuccess: `Correo de voz movido exitosamente.`,
        moveError: `No se pudo mover el correo de voz.`,
        deleteSuccess: `Correo de voz eliminado exitosamente.`,
        deleteError: `No se pudo eliminar el correo de voz.`,
        markUnreadSuccess: `Correo de voz marcado como no leído.`,
        markUnreadError: `No se pudo marcar el correo de voz como no leído.`,
        copyLinkSuccess: `Enlace Copiado al Portapapeles`,
        copySuccess: `Copiado al portapapeles`,
        copyError: `No se pudo copiar al portapapeles`,
        extensionSwitched: `Extensión cambiada a:`,
        pbxChanged: `PBX cambiado a:`,
        globalPhoneHotKeySuccess: `Teclas de acceso rápido del teléfono global guardadas exitosamente`,
        globalPhoneHotKeyError: `No se pudieron guardar las teclas de acceso rápido del teléfono global.`,
        globalPhoneHotKeyDisabled: `Tecla de acceso rápido deshabilitada.`,
        globalPhoneHotKeyEnabled: `Tecla de acceso rápido habilitada.`,
      },
      input: {
        defaultPlaceholder: `Escribe aquí`,
      },
      timeAgo: {
        justNow: `justo ahora`,
        minutesAgo_one: `hace {{count}} min`,
        minutesAgo_other: `hace {{count}} mins`,
        hoursAgo_one: `hace {{count}} hora`,
        hoursAgo_other: `hace {{count}} horas`,
        daysAgo_one: `hace {{count}} día`,
        daysAgo_other: `hace {{count}} días`,
      },
      currency: {
        default: `{{value, currency}}`,
        withCode: `{{value, currency, currencyCode}}`,
      },
    },

    contactSearchInput: {
      placeholder: `Escribe un nombre o número`,
      invalidPhoneNumber: `Número de teléfono inválido`,
      noNumber: `Sin número`,
    },

    newCallModal: {
      header: `Nueva Llamada`,
      sendToWebPhone: `Enviar al Teléfono Web`,
      sendToDeskPhone: `Enviar al Teléfono Fijo (Yealink)`,
      from: `De`,
      to: `Para`,
      answerHandsetWhenItRings: `Contesta tu teléfono cuando suene.`,
      attemptingToEstablishCallTo: `Intentando establecer llamada a {{phoneNumber}}...`,
      checkInternetConnection: `Por favor, verifica tu conexión a internet e inténtalo de nuevo.`,
      tryAgain: `Intentar de Nuevo`,
      establishingCallTo: `Estableciendo llamada a {{phoneNumber}}...`,
      failedToEstablishCallTo: `Error al establecer llamada a {{phoneNumber}}.`,
    },

    confirmBlockNumberModal: {
      title: `Bloquear {{formattedPhoneNumber}}`,
      message: `Tu PBX ya no recibirá llamadas, mensajes de texto o faxes de este número.`,
      confirmText: `Bloquear Número`,
      cancelText: `Cancelar`,
      toastBlockError: `Hubo un problema al bloquear {{formattedPhoneNumber}}, por favor, inténtalo de nuevo.`,
      toastUnblockError: `Hubo un problema al desbloquear {{formattedPhoneNumber}}, por favor, inténtalo de nuevo.`,
    },

    blockedNumbers: {
      addNumber: `Agregar Número`,
      headerSubtext: `Todas las llamadas, mensajes de texto y faxes de los números listados a continuación serán bloqueados.`,
      header: `Números Bloqueados`,
      clearButton: `Borrar`,
      blockButton: `Bloquear Número`,
      modalSubtext: `Todas las llamadas, mensajes de texto y faxes de los números listados a continuación serán bloqueados.`,
      noBlockedNumbers: `No se encontraron números bloqueados.`,
      unblockTooltip: `Desbloquear`,
      unblockNumberLabel: `Desbloquear {{formattedPhoneNumber}}`,
      numberUnblocked: `{{formattedPhoneNumber}} desbloqueado`,
      confirmUnblock: {
        title: `¿Desbloquear {{formattedPhoneNumber}}?`,
        message: `Su PBX volverá a recibir llamadas, mensajes de texto y faxes de este número.`,
        confirmText: `Desbloquear número`,
        cancelText: `Cancelar`,
      },
    },
    a11y: {
      messages: {
        senderContact: `Contacto`,
        senderYou: `Tú`,
        senderTeam: `Tu equipo`,
        messageMeta: `{{sender}}, {{time}}:`,
        newMessage: `Nuevo mensaje de {{sender}}: {{body}}`,
        newMessages: `{{count}} mensajes nuevos de {{sender}}`,
        attachment: `Archivo adjunto`,
        messageSent: `Mensaje enviado`,
        messageFailed: `No se pudo enviar el mensaje. Puedes reintentarlo.`,
        openImage: `Abrir imagen {{name}}`,
        imageFrom: `Imagen de {{sender}}`,
        downloadFile: `Descargar {{name}}`,
      },
      composer: {
        label: `Mensaje`,
        labelWithName: `Mensaje para {{name}}`,
      },
      toast: {
        close: `Cerrar`,
      },
      nav: {
        notificationCount: `{{count}} nuevos`,
      },
      filterGroup: {
        text: `Filtro de mensajes de texto`,
        voicemail: `Filtro de buzón de voz`,
        fax: `Filtro de fax`,
        snippets: `Filtro de fragmentos`,
      },
      recipient: {
        label: `Nombre o número del destinatario`,
        listLabel: `Contactos sugeridos`,
        results: `Contactos encontrados: {{count}}`,
      },
    },

    messageInput: {
      statusMessage: {
        uploading: `Subiendo...`,
        failedToUpload: `No se pudo subir`,
      },
      attachMedia: `Adjuntar Medios`,
      addSnippet: `Agregar Fragmento`,
      emojis: `Emojis 😃`,
      sendText: `Enviar Mensaje de Texto`,
      inputPlaceholder: `Envía un mensaje aquí`,
      retry: `Reintentar`,
    },

    messagingPage: {
      emptyDetailViewMessage: `Ningún Hilo Seleccionado`,
      errorToastMessage: `Número de teléfono inválido`,
      textPlaceholder: {
        receivedFile: `Archivo Recibido`,
        fileSent: `Archivo Enviado`,
      },
      subheadingText: `{{phoneNumber, phone}} de`,
    },

    newFaxModal: {
      header: `Nuevo Fax`,
      footer: {
        sendButtonText: `Enviar`,
      },
      loadingView: {
        sendingFax: `Enviando fax...`,
      },
    },

    newFaxForm: {
      dropdownPlaceholder: `De...`,
      textAreaPlaceholder: `Ingresa una nota para la página de portada`,
      switchText: {
        includeCoverPage: `Incluir Página de Portada`,
        sendEmailConfirmation: `Enviar Confirmación por Correo Electrónico`,
      },
      dropzonePlaceholder: `Puedes enviar faxes de hasta 25mb`,
      tagInputPlaceholder: `Ingresa la dirección de correo electrónico y presiona "Enter"`,
      tagInputGuideText: `Puedes enviar hasta {{maxEmailConfirmations}} direcciones de correo electrónico`,
      coverPageNoteLabel: `Nota de la portada`,
      emailConfirmationsLabel: `Correos electrónicos de confirmación`,
      emailValueType: `correo electrónico`,
    },

    sizeGauge: {
      totalSize: `Tamaño Total: {{totalSize}} / {{sizeLimit}}`,
      exceededSize: `Excedido por {{exceededSize}}`,
    },

    contentDefault: {
      placeholder: `Arrastra y suelta el archivo aquí, o haz clic para buscar`,
    },

    contentAcceptedMulti: {
      previewFile: `Vista previa de {{fileName}}`,
      removeFile: `Eliminar {{fileName}}`,
      fileRemoved: `{{fileName}} eliminado`,
      moveUp: `Mover {{fileName}} hacia arriba`,
      moveDown: `Mover {{fileName}} hacia abajo`,
      fileMoved: `{{fileName}} se movió a la posición {{position}} de {{total}}`,
      possibleDuplicate: `Posible duplicado`,
      tooLarge: `Demasiado grande`,
      possibleDuplicateAndTooLarge: `Posible duplicado, demasiado grande`,
      fileWithStatus: `{{file}} – {{status}}`,
    },

    newThreadModal: {
      header: {
        newThread: `Nuevo Hilo`,
        noGroupFound: `No se encontró ningún grupo`,
      },
      sendButtonText: `Enviar`,
      contactText1: `Esta extensión no forma parte de un grupo de mensajería.`,
      contactText2: `Dirígete a {{adminUrl}} y configura tu grupo de mensajería, o contacta a tu Administrador de Mango.`,
      contactLinkText: `¿Qué es un Grupo de Mensajería?`,
      placeholder: `Tu mensaje`,
    },

    deleteConfirmModal: {
      title: `¿Eliminar Correo de Voz?`,
      message: `Esto es permanente y no se puede deshacer.`,
      deleteButton: `Eliminar`,
      cancelButton: `Cancelar`,
    },

    confirmModal: {
      defaultTitle: `¿Estás seguro?`,
      confirmDeleteVoicemail: `Eliminar este correo de voz es permanente y no se puede deshacer.`,
      dontAskAgain: `No volver a preguntar`,
    },

    emptySearch: {
      shoot: `Vaya.`,
      nothingIsMatching: `Nada coincide`,
      didYouSpellItRight: `¿Lo escribiste bien?`,
    },

    listItem: {
      unreadStatus: `No leído`,
      markedAsUnread: `Marcado como no leído`,
      markedAsRead: `Marcado como leído`,
    },

    messageThreadHeader: {
      rename: `Renombrar`,
      cancel: `Cancelar`,
      threadNameLabel: `Nombre de la conversación`,
    },

    dropZoneMappings: {
      fileToLarge: {
        title: `Archivo Demasiado Grande`,
        description: `Parece que el archivo que intentas subir es demasiado grande. El tamaño máximo del archivo es {{maxFileSize}}MB`,
      },
      fileInvalidType: {
        link: `Más información`,
        title: `Tipo de Archivo no Soportado`,
        faxDescription: `Parece que ese archivo es de un tipo no soportado. {{link}} sobre tipos de archivo soportados`,
        description: `Parece que ese archivo es de un tipo no soportado. Más información sobre los tipos de archivo soportados en {{urlLink}}`,
      },
      fileUploadFailed: {
        title: `Error de Carga`,
        description: `Parece que el archivo que intentas subir falló. Por favor, inténtalo de nuevo.`,
      },
      general: {
        title: `Ha ocurrido un error inesperado`,
        description: `Ha ocurrido un error inesperado, por favor, inténtalo de nuevo.`,
      },
    },

    messageThreads: {
      emptyState: {
        title: `No hay Mensajes de Texto`,
        subtitle1: `Aún no has enviado ni recibido ningún mensaje de texto`,
        subtitle2: `Envía un mensaje de texto para empezar`,
      },
      searchPlaceholder: `Buscar un nombre o número`,
      searchLabel: `Buscar mensajes`,
      allGroups: `Todos los Grupos`,
      new: `{{count}} Nuevo - ver todo`,
      markAllRead: `Marcar Todo como Leído`,
      buttonText: `Nuevo Mensaje de Texto`,
    },

    phoneOptions: {
      recent: `Recientes`,
      missed: `Perdidas`,
    },

    chatOptions: {
      recent: `Recientes`,
      unread: `No leídos`,
    },

    snippetOptions: {
      pbx: `PBX`,
      personal: `Personal`,
    },

    chatMenu: {
      label: `Fragmentos`,
      settings: `Configuración de fragmentos`,
    },

    phoneMenu: {
      label: `Respuesta Automática`,
    },

    generalMenu: {
      label: `Enviar Comentarios`,
    },

    experimentsMenu: {
      label: `Teléfono Web`,
    },

    developMenu: {
      notifications: `Notificaciones`,
      contacts: `Contactos`,
    },

    callState: {
      inboundAnswered: `Entrante Contestada`,
      outboundAnswered: `Saliente Contestada`,
      inboundMissedOrDeclined: `Entrante Perdida o Rechazada`,
      outboundMissedOrDeclined: `Saliente Perdida o Rechazada`,
    },

    voicemailState: {
      received: `Recibiste un correo de voz`,
      sent: `Dejaste un correo de voz`,
    },

    voicemailOptions: {
      recent: `Recientes`,
      unread: `No leídos`,
    },

    mangoPhoneTypes: {
      mobile: `Móvil`,
      work: `Trabajo`,
      home: `Casa`,
    },

    mangoContactTypes: {
      mango: `Mango Voice`,
    },

    markReadModal: {
      header: `Precaución - Marcar Todo como Leído`,
      message: `Marcar todos los hilos como leídos NO se puede deshacer`,
      confirmText: `¿Estás seguro?`,
      confirmButton: `Confirmar`,
    },

    faxViewList: {
      titleNoFaxes: `No hay Faxes`,
      titleNoMatchingFaxes: `No hay Faxes que Coincidan`,
      subtitleTryRemovingFilters: `Intenta quitar algunos filtros`,
      subtitleNoFaxes: `Parece que no tienes ningún fax.`,
      buttonTextStartFax: `Iniciar un Fax`,
      buttonTextStartFirstFax: `Iniciar tu primer Fax`,
      searchPlaceholder: `Buscar un nombre o número`,
      searchLabel: `Buscar faxes`,
      status: {
        failed: `Fallido`,
        pending: `Procesando`,
        sent: `Enviado`,
        received: `Recibido`,
        unknown: `Desconocido`,
      },
    },

    pdfToolbar: {
      print: `Imprimir`,
      download: `Descargar`,
      openInNewTab: `Abrir en Nueva Pestaña`,
      firstPage: `Primera página`,
      previousPage: `Página anterior`,
      nextPage: `Página siguiente`,
      lastPage: `Última página`,
      rotate: `Girar`,
      pageStatus: `Página {{pageNumber}} de {{pages}}`,
    },

    toolbar: {
      clearAll: `Borrar Todo`,
      potentialDuplicates: `Posibles Duplicados`,
    },

    call: {
      toast: {
        callDeclined: `Llamada de {{context}} rechazada`,
        callEnded: `Llamada con {{context}} finalizada`,
        callHeld: `Llamada con {{context}} en espera`,
        callParked: `{{callName}} transferida a {{parkingLotName}}`,
        callParkFailed: `Error al estacionar {{callName}} en {{parkingLotName}}`,
        callTargetUndialable: `No se puede llamar a {{target}}: revise el número e inténtelo de nuevo`,
        callTransferred: `{{callName}} transferida a {{transferToName}}`,
        callTransferFailed: `Error al transferir {{callName}} a {{transferToName}}`,
        callUnavailable: `Teléfono desconectado - no se puede realizar la llamada`,
      },
    },

    incomingCallModal: {
      newCallFrom: `Nueva Llamada de`,
      rejectCall: `Rechazar Llamada`,
      acceptCall: `Aceptar Llamada`,
      endAndAccept: `Finalizar y Aceptar`,
      holdAndAccept: `Poner en Espera y Aceptar`,
      parkAndAccept: `Estacionar y Aceptar`,
    },

    popupCallButtons: {
      accept: `Aceptar`,
      reject: `Rechazar`,
      endAndAccept: `Finalizar y Aceptar`,
      holdAndAccept: `Retener y Aceptar`,
      parkAndAccept: `Aparcar y Aceptar`,
      switch: `Cambiar`,
      resume: `Reanudar`,
      end: `Finalizar`,
      tooltip: {
        accept: `Aceptar llamada entrante`,
        reject: `Rechazar llamada entrante`,
        endAndAccept: `Finalizar llamada actual y aceptar llamada entrante`,
        holdAndAccept: `Poner llamada actual en espera y aceptar llamada entrante`,
        parkAndAccept: `Aparcar llamada actual y aceptar llamada entrante`,
        switch: `Cambiar a esta llamada`,
        resume: `Reanudar esta llamada`,
        end: `Finalizar esta llamada`,
      },
    },

    callStatus: {
      deskPhone: `Teléfono de Escritorio`,
      onHold: `En Espera`,
      ringing: `Sonando`,
      connected: `Conectado`,
      connecting: `Conectando`,
      ready: `Listo`,
      dialing: `Marcando...`,
      reconnecting: `Reconectando...`,
      onDeskPhone: `En teléfono de escritorio`,
      connectedWithDuration: `Conectado {{duration}}`,
      shortDial: `Marcar`,
      shortRing: `Timbre`,
      shortHold: `Espera`,
      shortConn: `Conec.`,
      shortDesk: `Escrit.`,
    },

    callAnnouncements: {
      incomingCall: `Llamada entrante de {{name}}, {{number}}`,
      incomingCallNameOnly: `Llamada entrante de {{name}}`,
      connected: `Conectado`,
      onHold: `En espera`,
      resumed: `Llamada reanudada`,
      muted: `Micrófono silenciado`,
      unmuted: `Micrófono activado`,
      callEnded: `Llamada finalizada`,
      answerFailed: `No se pudo contestar la llamada`,
      holdFailed: `No se pudo poner la llamada en espera`,
      resumeFailed: `No se pudo reanudar la llamada`,
    },

    callSoundIndicator: {
      onHold: `En Espera`,
      muted: `Silenciado`,
      reconnecting: `Reconectando`,
    },

    popup: {
      tabs: {
        inboundCalls: `Llamadas`,
        messages: `Mensajes`,
      },
      emptyStates: {
        noCalls: {
          title: `No se encontraron llamadas`,
          description: `Actualmente no hay llamadas entrantes disponibles`,
        },
        noActiveCalls: `No hay llamadas activas`,
        noMessages: {
          title: `No se encontraron mensajes`,
          description: `Actualmente no hay mensajes disponibles`,
        },
      },
      footer: {
        poweredByMango: `Desarrollado por Mango Voice`,
      },
      callButtons: {
        deskPhoneActive: `Llamada activa en teléfono de escritorio`,
        dismiss: `Descartar`,
      },
      callItem: {
        unknownCaller: `Llamador Desconocido`,
        unknownNumber: `Número Desconocido`,
        onHold: `En Espera`,
        pageIntercom: `Buscar/Intercomunicador`,
        callDetails: `Detalles de la llamada`,
      },
      messageButtons: {
        dismiss: `Descartar`,
        openMessage: `Abrir Mensaje`,
      },
      personCard: {
        patientFile: `Expediente del Paciente`,
        fullName: `Nombre Completo`,
        dateOfBirth: `Fecha de Nacimiento`,
        patientNumber: `Número de Paciente`,
        inboundNumber: `Número Entrante`,
        extension: `Extensión`,
        defaultLocation: `Ubicación Predeterminada`,
        nextAppointment: `Próxima Cita`,
        previousAppointment: `Cita Anterior`,
        insurance: `Seguro`,
        balance: `Saldo`,
      },
      header: {
        expand: `Expandir`,
        minimize: `Minimizar`,
        dismiss: `Descartar`,
        logoAlt: `Logo`,
      },
    },

    faxPage: {
      toast: {
        copyLinkSuccess: `Enlace Copiado al Portapapeles`,
        copyLinkError: `No se pudo copiar el enlace al portapapeles.`,
        sendSuccess: `Tu fax ha sido agregado a la cola y se enviará en breve`,
        sendError: `Hubo un problema al enviar tu fax. Por favor, inténtalo de nuevo`,
        deleteSuccess: `Fax eliminado exitosamente`,
        deleteError: `Hubo un problema al eliminar este fax. Por favor, inténtalo de nuevo`,
        unexpectedError: `Ocurrió un error inesperado`,
      },
      confirmDelete: {
        title: `Eliminar Fax`,
        message: `¿Estás seguro de que quieres eliminar este fax?`,
        button: `Eliminar`,
        cancel: `Cancelar`,
      },
      confirmResend: {
        title: `Reenviar Fax`,
        message: `¿Estás seguro de que quieres reenviar este fax?`,
        button: `Reenviar`,
        cancel: `Cancelar`,
      },
      emptyStateMessage: `Ningún Fax Seleccionado`,
      status: {
        queued: `En Cola`,
        received: `Recibido`,
        sent: `Enviado`,
      },
      direction: {
        to: `Para`,
        from: `De`,
      },
      detailsHeader: {
        status: `{{statusPrefix}} el {{statusDate}} a las {{statusTime}} {{directionText}}`,
      },
    },

    secureFaxPage: {
      logoAlt: `Mango Voice logo`,
      loading: {
        title: `Verificando Enlace de Fax Seguro`,
        description: `Por favor, espera mientras verificamos este enlace de fax seguro.`,
      },
      password: {
        title: `Acceso al Fax Seguro`,
        description: `Ingresa la contraseña del fax seguro para acceder a este fax.`,
        label: `Contraseña del fax seguro`,
        placeholder: `Ingresa la contraseña`,
        submitButton: `Ver Fax Seguro`,
        submittingButton: `Verificando contraseña...`,
      },
      errors: {
        password_required: `La contraseña es obligatoria.`,
        invalid_password: `La contraseña que ingresaste es incorrecta.`,
        s3_error: `No se pudo preparar la vista previa del fax seguro. Por favor, inténtalo de nuevo.`,
        throttled: `Demasiadas solicitudes. Por favor, espera un momento e inténtalo de nuevo.`,
        unknown: `Algo salió mal. Por favor, inténtalo de nuevo.`,
        attemptsRemaining: `Intentos restantes: {{count}}`,
      },
      status: {
        expired: {
          title: `Enlace Expirado`,
          description: `Este enlace de fax seguro ha expirado. Por favor, solicita un nuevo enlace de fax seguro.`,
        },
        disabled: {
          title: `Enlace Deshabilitado`,
          description: `Este enlace de fax seguro ha sido deshabilitado.`,
        },
        not_found: {
          title: `Enlace No Encontrado`,
          description: `No pudimos encontrar este enlace de fax seguro.`,
        },
        max_downloads_reached: {
          title: `Límite de Descargas Alcanzado`,
          description: `Este enlace de fax seguro ha alcanzado su número máximo de descargas.`,
        },
        too_many_attempts: {
          title: `Demasiados Intentos`,
          description: `Este enlace de fax seguro ha sido bloqueado después de demasiados intentos de contraseña.`,
        },
        throttled: {
          title: `Demasiadas Solicitudes`,
          description: `Se hicieron demasiadas solicitudes para este enlace. Por favor, inténtalo de nuevo en un momento.`,
        },
        unknown: {
          title: `No Se Pudo Cargar el Fax Seguro`,
          description: `No pudimos verificar este enlace de fax seguro.`,
        },
        actions: {
          checkAgain: `Verificar de Nuevo`,
        },
      },
      download: {
        title: `Fax Seguro Listo`,
        description: `Tu fax seguro está listo. Este enlace de descarga caduca pronto, descárgalo ahora.`,
        detailsTitle: `Detalles del Fax`,
        fromLabel: `De`,
        toLabel: `Para`,
        receivedLabel: `Recibido`,
        downloadsRemainingLabel: `Descargas Restantes`,
        actions: {
          download: `Descargar Fax`,
          openInNewTab: `Abrir en una Nueva Pestaña`,
          tryAnotherPassword: `Probar Otra Contraseña`,
        },
        fetchError: {
          title: `No Se Pudo Cargar la Vista Previa`,
          description: `No pudimos cargar la vista previa del fax seguro desde el enlace de descarga.`,
          retryPreview: `Reintentar Vista Previa`,
          generic: `Error al cargar la vista previa del fax seguro.`,
        },
      },
    },

    voicemail: {
      emptyState: {
        title: `No hay Correos de Voz`,
        subtitle1: `Parece que estás contestando todas tus llamadas. ¡Sigue así!`,
        subtitle2: `Si crees que te faltan correos de voz, contacta a nuestro equipo de soporte.`,
        buttonText: `Contactar Soporte`,
      },
      searchPlaceholder: `Buscar por nombre o número de llamante`,
      searchLabel: `Buscar mensajes de voz`,
      emptyDetailViewMessage: `Ningún Correo de Voz Seleccionado`,

      mangoModal: {
        title: `Mover`,
        headerText: `Mover Correo de Voz`,
        cancelButtonText: `Cancelar`,
        moveButtonText: `Mover Correo de Voz`,
        selectVoicemailBoxText: `Seleccionar Buzón de Correo de Voz...`,
        markAsUnreadText: `Marcar como no leído en el buzón seleccionado`,
        destinationBoxText: `Buzón de Correo de Voz de Destino`,
        destinationBoxWarning: `Este correo de voz no estará disponible si no tienes acceso al Buzón de Correo de Voz de destino.`,
      },

      detailView: {
        headerSubheadingText: `De`,
        headerSubheadingToText: `Para`,
        audioPlayerTitle: `Audio del Correo de Voz`,
        transcriptionText: `Transcripción`,
      },

      loadingText: `Correo de Voz`,
      transcriptionTitleText: `Transcripción`,

      move: {
        error: `Ocurrió un error al mover el correo de voz.`,
        success: `Correo de voz movido exitosamente`,
        successMarkAsUnread: `Correo de voz movido exitosamente y marcado como no leído`,
        successMarkAsRead: `Correo de voz movido exitosamente`,
      },

      filter: {
        all: `Todos`,
        unread: `No leídos`,
        allInboxes: `Todas las Bandejas de Entrada`,
      },

      tooltip: {
        move: `Mover`,
        delete: `Eliminar`,
        markAsUnread: `Marcar como no leído`,
        markAsRead: `Marcar como leído`,
        blockNumber: `Bloquear número`,
        unblockNumber: `Desbloquear número`,
        copyLink: `Copiar Enlace al Portapapeles`,
        editContact: `Editar Contacto`,
        newCall: `Nueva Llamada`,
        newText: `Nuevo Mensaje de Texto`,
        resendFax: `Reenviar Fax`,
        moveFax: `Mover Fax`,
        newFax: `Nuevo Fax`,
        close: `Cerrar`,
      },

      copyLinkError: `No se pudo copiar el enlace al portapapeles.`,
    },

    audioPlayer: {
      rewind10s: `Rebobinar 10s`,
      play: `Reproducir`,
      pause: `Pausar`,
      mute: `Silenciar`,
      unmute: `Activar sonido`,
      fastForward10s: `Avanzar 10s`,
      jumpToAnswer: `Saltar a la Respuesta`,
      changePlaybackSpeed: `Cambiar Velocidad de Reproducción`,
      downloadAudio: `Descargar Audio`,
      seeKeyboardShortcuts: `Ver Atajos de Teclado`,
      mediaError: `Hubo un problema al cargar este archivo de audio.`,
      noAudio: `No hay Grabación Disponible`,
      playbackPosition: `Posición de reproducción`,
      playbackPositionValue: `{{position}} de {{duration}}`,
    },

    fax: {
      filter: {
        all: `Todos`,
        unread: `No leídos`,
        allInboxes: `Todas las Bandejas de Entrada`,
        sent: `Enviados`,
        received: `Recibidos`,
      },
      tooltip: {
        pending: `Este fax está en proceso y se enviará en breve`,
      },
    },

    pbxPrompt: {
      loggingIn: `Iniciando sesión...`,
      loadingPbxs: `Cargando PBXs...`,
      selectPbx: `Selecciona tu PBX`,
      noPbxMessage: `Actualmente no eres miembro de ningún sistema telefónico (PBX). Para usar esta aplicación, comunícate con la persona en tu oficina que administra el sistema telefónico para que te agregue.`,
      noPbxErrorMessage: `Si crees que esto es un error, contacta al Soporte de Mango para obtener más ayuda.`,
      callSupport: `Llamar al soporte`,
      emailSupport: `Enviar correo al soporte`,
      back: `Atrás`,
      errorTitle: `¡Ups! Algo salió mal.`,
      errorMessage: `Por favor, inténtalo de nuevo o contacta al soporte.`,
    },

    pbxPicker: {
      searchPlaceholder: `Buscar PBXs...`,
      current: `Actual`,
      recent: `Recientes`,
      allPbxs: `Todos los PBXs`,
      searchResults: `Resultados de búsqueda`,
      noResults: `No se encontraron PBXs`,
      searchPrompt: `Buscar un PBX por nombre`,
      switchPbx: `Cambiar PBX`,
      count: `{{count}} PBXs`,
      countFiltered: `{{count}} PBXs encontrados`,
    },

    pbxHeaderSwitcher: {
      selectPbx: `Seleccionar PBX`,
      ariaLabel: `Cambiar PBX`,
    },

    loginPrompt: {
      loginFailedError: `Error de inicio de sesión. Por favor, inténtalo de nuevo.`,
      invalidEmail: `¡Dirección de correo electrónico no válida!`,
      enterUsername: `Por favor, ingresa el nombre de usuario`,
      enterPassword: `Por favor, ingresa una contraseña`,
      invalidCredentials: `Nombre de usuario o contraseña no válidos, por favor verifica tus credenciales e inténtalo de nuevo.`,
      usernamePlaceholder: `correo electrónico / nombre de usuario`,
      passwordPlaceholder: `contraseña`,
      logIn: `Iniciar Sesión`,
      forgotPassword: `¿Olvidaste tu contraseña?`,
      openSupportForm: `Abrir formulario de soporte`,
      backToLogin: `Volver al inicio de sesión`,
      showPassword: `Mostrar contraseña`,
    },

    desktopAppBanner: {
      tryDesktopApp: `Prueba la aplicación de escritorio {{appName}} para la mejor experiencia`,
      desktopAppName: `{{appName}} Escritorio`,
      launchAppTooltip: `Iniciar aplicación de escritorio si está instalada`,
      downloadAppTooltip: `Descargar aplicación de escritorio`,
      launchApp: `Iniciar App`,
      download: `Descargar`,
      settings: `Ajustes`,
      dontAskAgain: `No preguntar de nuevo`,
      remindMeLater: `Recordarme más tarde`,
      alwaysOpenHint: `Para abrir siempre los enlaces en la aplicación de escritorio, cámbialo en Ajustes.`,
      launchConfirmTitle: `Abrir en la aplicación de escritorio`,
    },
    openApp: {
      title: `Abriendo tu aplicación de escritorio…`,
      subtitle: `Estamos abriendo la aplicación ahora. Si no se abre automáticamente, usa el botón de abajo.`,
      closeHint: `Puedes cerrar esta pestaña una vez que la aplicación se abra.`,
      openButton: `Abrir aplicación de escritorio`,
      fallbackPrompt: `¿No tienes instalada la aplicación de escritorio?`,
      downloadButton: `Descargar la aplicación de escritorio`,
    },

    openedInDesktop: {
      title: `Intentamos abrir esta página en la aplicación de escritorio`,
      subtitle: `Si se abrió la aplicación de escritorio de {{appName}}, puedes cerrar esta pestaña.`,
      continueInBrowser: `Continuar en el navegador`,
      tryAgain: `Intentar de nuevo`,
      stopOpeningInDesktop: `Dejar de abrir enlaces en la aplicación de escritorio`,
      settingsHint: `Para mantener los enlaces en este navegador, cambia <settingsLink>Aplicación de escritorio en Configuración</settingsLink>.`,
    },

    profileSettings: {
      myProfile: `Mi perfil`,
      editProfile: `Editar perfil`,
      name: `Nombre`,
      username: `Usuario`,
      email: `Correo electrónico`,
      openDesktopApp: `Abrir Aplicación de Escritorio`,
      launchDesktopApp: `Iniciar Aplicación de Escritorio`,
      callSupport: `Llamar a Soporte`,
      emailSupport: `Enviar Correo Electrónico a Soporte`,
      sendFeedback: `Enviar Comentarios`,
      whatsNew: `Novedades`,
      downloadApp: `Descargar Aplicación`,
      logOut: `Cerrar Sesión`,
      needHelp: `¿Necesitas Ayuda?`,
      switchPbx: `Cambiar PBX`,
      pbxName: `Nombre del PBX`,
      darkMode: `Modo Oscuro`,
      darkModeOptions: {
        light: `Claro`,
        dark: `Oscuro`,
        system: `Usar configuración del sistema`,
      },
      language: `Idioma`,
      desktopApp: {
        label: `Aplicación de Escritorio`,
        beta: `Beta`,
        modeLabel: `Cuando abro un enlace de {{appName}} en este navegador`,
        modeHint: `Esta configuración solo se aplica a este navegador.`,
        modes: {
          ask: `Preguntarme (mostrar un aviso)`,
          always: `Abrir siempre en la aplicación de escritorio`,
          never: `No preguntar`,
        },
        testLaunch: {
          title: `Abrir enlaces en la aplicación de escritorio`,
          question: `Intentamos abrir la aplicación de escritorio de {{appName}}. ¿Se abrió?`,
          yes: `Sí, se abrió`,
          no: `No, no se abrió`,
          notOpened: `Los enlaces seguirán abriéndose en este navegador. Instala la aplicación de escritorio de {{appName}} y vuelve a intentarlo.`,
          tryAgain: `Intentar de nuevo`,
          close: `Cerrar`,
        },
      },
      switchPbxConfirmation: {
        title: `Cambiar tu PBX Actual`,
        message: `Las llamadas, mensajes de texto, faxes y correos de voz de {{pbxName}} no estarán disponibles en esta aplicación hasta que vuelvas a cambiar.`,
        confirmText: `Ok`,
        cancelText: `Cancelar`,
      },
      editMyProfile: {
        title: `Editar Mi Perfil`,
        update: `Actualizar Perfil`,
        close: `Cerrar`,
        firstName: `Nombre`,
        lastName: `Apellido`,
        username: `Nombre de Usuario`,
        email: `Correo Electrónico`,
        errRequiredFirstName: `Por favor, ingresa el Nombre.`,
        errRequiredLastName: `Por favor, ingresa el Apellido.`,
        successProfile: `Perfil actualizado correctamente.`,
      },
    },

    pbxQuerySwitch: {
      confirm: {
        title: `¿Configurar este PBX?`,
        message: `¿Quieres configurar tu PBX como {{pbxName}}?`,
        confirmText: `Configurar PBX`,
        cancelText: `Cancelar`,
      },
      warning: {
        invalid: {
          title: `Enlace de PBX no válido`,
          description: `El enlace de PBX no es válido. Inténtalo de nuevo desde Admin.`,
        },
        inaccessible: {
          title: `No se puede cambiar de PBX`,
          description: `No tienes acceso a ese PBX.`,
        },
      },
    },

    languageSelector: {
      title: `Preferencias de Idioma`,
      selectLanguage: `Seleccionar Idioma`,
      autoDetect: `Detectar Automáticamente (Idioma del Sistema)`,
      languages: {
        en: `Inglés`,
        'en-US': `Inglés (Estados Unidos)`,
        'en-GB': `Inglés (Reino Unido)`,
        'en-CA': `Inglés (Canadá)`,
        es: `Español`,
        'es-MX': `Español (México)`,
        'es-US': `Español (Estados Unidos)`,
        'fr-CA': `Francés (Canadá)`,
        ko: `Coreano`,
        ne: `Nepalí`,
        te: `Telugu`,
      },
    },

    snippetsSettings: {
      confirmationModal: {
        title: `¿Estás seguro?`,
        message: `Eliminar este fragmento es permanente y no se puede deshacer`,
        confirmText: `Eliminar`,
        cancelText: `Cancelar`,
      },
      errorWithTimeout: `Algo salió mal. Por favor, inténtalo de nuevo más tarde.`,
      headerText: `Fragmentos`,
      newButtonText: `Nuevo`,
      tooltipDelete: `Eliminar`,
      editSnippetLabel: `Editar fragmento {{name}}`,
      deleteSnippetLabel: `Eliminar fragmento {{name}}`,
      cancelEditing: `Cancelar edición`,
      dismissError: `Descartar error`,
      editSnippet: `Editar Fragmento`,
      newSnippet: `Nuevo Fragmento`,
      shortcut: `Atajo`,
      inputPlaceholder: `BuenosDías`,
      shortcutGuideText: `Una palabra, sin espacios. Ej.: #buenos-dias o #ResultadosDePrueba`,
      visibility: `Visibilidad`,
      visibilityGuideText: `Personal = solo tú puedes acceder, Compañía = todos accederán`,
      editBodyInputPlaceholder: `Escribe un mensaje predefinido aquí. Puedes añadir correos electrónicos, enlaces web, números de teléfono...`,
      mangoButtonCancel: `Cancelar`,
      mangoButtonSave: `Guardar`,
      loadingSnippets: `Cargando Fragmentos...`,
      noSnippetsFound: `No se encontraron Fragmentos`,
      body: `Cuerpo`,
      personal: `Personal`,
      filter: {
        all: `Todos`,
        unread: `No leídos`,
        allInboxes: `Todas las Bandejas de Entrada`,
      },
    },

    phoneSettings: {
      incomingCalls: `Llamadas Entrantes`,
      showInboundC2CCalls: `Mostrar Llamadas C2C Entrantes`,
      playRingtone: `Reproducir Tono de Llamada`,
      ringtone: `Tono de Llamada`,
      respondWithBusyToSecondCall: `Responder con Ocupado a la Segunda Llamada`,
      disabledInAgentMode: `Deshabilitado cuando el Modo Agente está activado`,
      outgoingCalls: `Llamadas Salientes`,
      defaultOutboundPhone: `Seleccionar teléfono predeterminado para llamadas salientes`,
      autoAnswer: `Respuesta Automática`,
      enableCallerIdSelection: `Habilitar Selección de Identificador de Llamada`,
      enableCallerIdSelectionDescription: `Te permite elegir el número de teléfono saliente al realizar llamadas.`,
      callerId: `Identificador de Llamada`,
      presence: `Presencia`,
      presenceDescription: `Las siguientes secciones se mostrarán en tu teléfono web, dándote acceso rápido a tus extensiones y números más marcados.`,
      parkingSpotsDisplayed: `Lugares de Estacionamiento Mostrados (Límite 5)`,
      removeParkingSpot: `Eliminar Lugar de Estacionamiento`,
      addParkingSpot: `Agregar Lugar de Estacionamiento`,
      lineExtensionsDisplayed: `Extensiones de Línea Mostradas (Límite 10)`,
      removeExtension: `Eliminar Extensión`,
      addExtension: `Agregar Extensión`,
      speedDial: `Marcación Rápida (Límite {{maxSpeedDials}})`,
      editSpeedDial: `Editar Marcación Rápida`,
      removeSpeedDial: `Eliminar Marcación Rápida`,
      addSpeedDial: `Agregar Marcación Rápida`,
      clickToCall: `Hacer Clic para Llamar`,
      sendToDeskPhone: `Enviar al Teléfono Fijo (Yealink)`,
      useWebPhone: `Usar Teléfono Web`,
    },

    phoneSettingItems: {
      selectExtension: `Seleccionar Extensión`,
      yourExtension: `Tu Extensión`,
      activateWebPhone: `Activar Teléfono Web`,
      confirmationModal: {
        title: `No hay Extensiones de Línea Disponibles`,
        message1: `No tienes extensiones de línea asignadas en este sistema telefónico ({{pbxName}}).`,
        message2: `Para usar la función de teléfono, contacta a tu administrador de sistema para asignar una extensión de línea.`,
        confirmText: `Descartar`,
        cancelText: `Cancelar`,
      },
    },

    extensionSelector: {
      selectExtension: `Seleccionar una Nueva Extensión`,
      deactivateWebPhone: `Desactivar Teléfono Web`,
      none: `Ninguno`,
      confirmationModal: {
        title: `Desvincular Dispositivo`,
        message: `Este dispositivo ya no enviará ni recibirá llamadas de {{extensionName}}.`,
        confirmText: `Ok`,
        cancelText: `Cancelar`,
      },
    },

    webPhone: {
      unknownCaller: `Llamador Desconocido`,
      selectParkingSpot: `Seleccionar un lugar de estacionamiento`,
      receivingCalls: `Recibiendo Llamadas`,
      doNotDisturb: {
        title: `No Molestar`,
        until: `Hasta {{time}}`,
        indefinite: `No molestar`,
        for30Minutes: `No molestar por 30 minutos`,
        for1Hour: `No molestar por 1 hora`,
        for2Hours: `No molestar por 2 horas`,
        untilTomorrow: `No molestar hasta mañana`,
        turnOff: `Desactivar no molestar`,
      },
      tooltip: {
        copied: `¡Copiado!`,
        copyCallerId: `Copiar ID del Llamador`,
        copyPhoneNumber: `Copiar número de teléfono`,
        endCall: `Terminar Llamada`,
        muteCall: `Silenciar Llamada`,
        answerCall: `Contestar Llamada`,
        switchToCall: `Cambiar a Llamada`,
        warmTransfer: `Transferencia Cálida`,
        holdCall: `Poner en Espera`,
        resumeCall: `Reanudar Llamada`,
        newCall: `Nueva Llamada`,
        mergeCalls: `Combinar Llamadas`,
        endConference: `Terminar Conferencia`,
      },
      callError: {
        youAreDisconnected: `Estás Desconectado`,
        connectionInterrupted: `Tu conexión fue interrumpida. Haz clic aquí para reintentar la conexión.`,
        reconnect: `Reconectar`,
        connecting: `Conectando…`,
        connectionFailed: `Error de conexión del teléfono. Inténtalo de nuevo.`,
        retry: `Reintentar`,
        microphoneDisabled: `¡Los permisos del micrófono están deshabilitados!`,
        microphoneEnableText: `Habilitar el permiso del micrófono te permitirá usar el teléfono web.`,
        microphoneInUse: `El micrófono está en uso`,
        microphoneInUseText: `Otra aplicación está usando tu micrófono. Ciérrala (por ejemplo, Zoom, Teams u otra pestaña) e inténtalo de nuevo.`,
        seeHereForHelp: `Consulta aquí para ayuda.`,
      },
      feedback: {
        reason: {
          soundDelayed: `El sonido estaba retrasado`,
          couldntHearOthers: `No podía oír a los demás`,
          echo: `Había eco`,
          audioBreakingUp: `El audio se cortaba`,
          othersCouldntHearMe: `Los demás no me oían`,
          otherAudioIssue: `Otro problema de audio`,
        },
        modal: {
          header: `¿Qué salió mal?`,
          dismiss: `Descartar`,
          submit: `Enviar comentarios`,
        },
        toast: {
          header: `Califica el audio de tu llamada`,
          thanks: `¡Gracias!`,
          goodQuality: `Buena calidad de llamada`,
          poorQuality: `Mala calidad de llamada`,
          dismiss: `Descartar`,
        },
      },
    },

    faxSettings: {
      enableFaxCoverPage: `Habilitar Página de Portada de Fax`,
    },

    notificationSettings: {
      alertMessage: `Has bloqueado las notificaciones. Deberás ir a la configuración de tu navegador para volver a activarlas.`,
      browserNotifications: `Notificaciones del Navegador`,
      playSoundForNewTexts: `Reproducir Sonido para Nuevos Mensajes de Texto`,
      testNotification: `Probar notificación`,
      volumeControl: `El volumen de la notificación se controla con tu computadora`,
      help: `Ayuda`,
      helpLinkText: `¿Cómo activo/desactivo las notificaciones?`,
      onGoogleChrome: `¿en Google Chrome?`,
      callPop: {
        title: `Ventana de Notificación de Llamadas y Mensajes`,
        description: `Prueba nuestra nueva función de ventana de notificación. Esta función mostrará una pequeña ventana separada cuando recibas una llamada o un mensaje de texto. ¡Esto te permite ver la información de llamadas y mensajes sin interrumpir tu trabajo!`,
        answerOnPatientInfoButtonClick: `Contestar llamada al abrir Información del Paciente`,
        showExampleButton: `Mostrar ejemplo`,
        enableExampleHint: `Activa el interruptor de arriba para habilitar el botón de ejemplo`,
      },
      popupPosition: {
        title: `Posición de la Ventana Emergente`,
        topLeft: `Arriba Izquierda`,
        topRight: `Arriba Derecha`,
        bottomLeft: `Abajo Izquierda`,
        bottomRight: `Abajo Derecha`,
      },
    },

    callInProgressModal: {
      title: `Llamada en progreso`,
      message: `Por favor termine su llamada actual antes de cambiar de extensión`,
      dismiss: `Descartar`,
    },

    sessionExpiredModal: {
      title: `Tu sesión ha expirado`,
      message: `Por tu seguridad, se cerró tu sesión. Los borradores de mensajes de texto se conservan en este dispositivo. Inicia sesión de nuevo para continuar.`,
      signInAgain: `Iniciar sesión de nuevo`,
    },

    audioSettings: {
      selectSoundOutputSource: `Seleccionar fuente de salida de sonido - altavoces`,
      selectInputSource: `Seleccionar fuente de entrada - micrófono`,
      toSelectAudioDevices: `Para seleccionar dispositivos de audio, por favor, otorga permisos de micrófono`,
    },

    integrationsSettings: {
      title: `Integraciones`,
      description: `Esta página muestra algunas de sus integraciones de fuentes de datos: conexiones que sincronizan datos entre Mango y su software de gestión de consultas. Es posible que tenga otras integraciones activas que aún no aparezcan aquí. Estamos trabajando en una experiencia de integraciones unificada que lo reunirá todo.`,
      configuration: `Configuración`,
      auth: `Autorización`,
      authDescription: `Esta integración requiere autorización para acceder a sus datos.`,
      authButton: `Autorizar`,
      authRegionNotSupported: `La autorización no está disponible en su región detectada. Si cree que esto es incorrecto (por ejemplo, si está usando una VPN), contacte a soporte.`,
      agentId: `ID: {{id}}`,
      copiedConfirmation: `¡Copiado!`,
      copyIdFailedTitle: `No se pudo copiar el ID`,
      unknownDate: `(desconocido)`,
      statusActive: `Activo`,
      statusPaused: `Pausado`,
      createdLabel: `Creado`,
      updatedLabel: `Actualizado`,
      notSet: `(no establecido)`,
      enabled: `Habilitado`,
      disabled: `Deshabilitado`,
      accessRestricted: `No tiene permiso para acceder a las integraciones. Contacte a su administrador para obtener acceso.`,
      emptyState: {
        primary: `Aún no hay integraciones de fuentes de datos gestionadas aquí.`,
        secondary: `Si tiene integraciones activas, es posible que aún no aparezcan en esta lista.`,
      },
      error: {
        title: `Error al cargar las integraciones`,
        message: `Ocurrió un error al cargar sus integraciones. Por favor, inténtelo de nuevo más tarde.`,
      },
    },

    updateSettings: {
      noExperimentsAvailable: `No hay experimentos ejecutándose en este momento.`,
      channelSwitcher: {
        title: `Cambio de Canal de Lanzamiento`,
        description: `Elige qué versión de actualizaciones recibir. Producción tiene las características más estables, mientras que los otros canales pueden ofrecer una vista previa de nuevas características. Cambiar de canal requiere reiniciar la aplicación.`,
        devModeNote: `Modo de Desarrollo: El cambio de canal es simulado y recargará la página en lugar de reiniciar la aplicación.`,
        releaseChannel: `Canal de Lanzamiento`,
        selectChannel: `Seleccionar canal...`,
        switchChannel: `Cambiar Canal`,
        rollback: `Revertir a {{channelName}}`,
        current: `Actual: {{channelName}}`,
        switchTo: `Cambiar a:`,
        error: `Canal No Disponible`,
        validationError: `No se puede cambiar a {{channelName}}. Es posible que el canal aún no esté disponible o que haya un problema de red. Por favor, inténtalo de nuevo más tarde.`,
        switchFailed: `No se pudo cambiar de canal. Inténtalo de nuevo.`,
        restartModal: {
          title: `Reinicio Requerido`,
          successMessage: `Cambiado exitosamente al canal <strong>{{channelName}}</strong>.`,
          warningMessage: `La aplicación necesita actualizarse y luego reiniciarse para completar el cambio de canal. Se perderá cualquier trabajo no guardado.`,
          cancel: `Cancelar`,
          restartNow: `Iniciar cambio`,
          switchingChannel: `Cambiando a {{channelName}}...`,
          checkingUpdates: `Buscando actualizaciones...`,
          downloadingUpdate: `Descargando actualización... {{progress}}%`,
          activatingChannel: `Activando canal...`,
          switching: `Cambiando...`,
        },
        highRiskWarning: {
          title: `Canal Inestable`,
          description: `Este canal puede contener características experimentales, errores o funcionalidades incompletas. Úselo bajo su propio riesgo.`,
        },
        mediumRiskWarning: {
          title: `Canal de Pre-lanzamiento`,
          description: `Este canal contiene software de pre-lanzamiento que puede tener errores o características incompletas.`,
        },
      },
      releaseNotifications: {
        title: `Notificaciones de Lanzamiento`,
        description: `Recibe un correo electrónico cuando se publique una nueva versión de la aplicación.`,
        descriptionWithChannel: `Recibe un correo electrónico cuando se publique una nueva versión de la aplicación en el canal {{channel}}.`,
        toggleLabel: `Enviarme un correo sobre nuevos lanzamientos`,
        recipient: `Las notificaciones se enviarán a la dirección de correo electrónico asociada con tu cuenta.`,
        recipientWithEmail: `Las notificaciones se enviarán a {{email}}.`,
        resubscribeNote: `Te diste de baja anteriormente. Al activar esto, tu correo electrónico volverá a suscribirse a los correos de novedades de versiones.`,
        error: `No se pudo actualizar tu configuración de notificaciones. Por favor, inténtalo de nuevo.`,
        loadError: `No se pudo cargar tu configuración de notificaciones.`,
        retry: `Reintentar`,
        previewButton: `Vista previa del correo`,
        previewModalTitle: `Ejemplo de correo de lanzamiento`,
        previewModalNote: `Un ejemplo de lo que recibirás. El contenido real varía según el lanzamiento. Los correos se envían en inglés.`,
        previewFrom: `De:`,
        previewSubject: `Asunto:`,
        previewClose: `Cerrar`,
        previewTipsTitle: `Asegúrate de recibir estos correos`,
        previewSenderTip: `Los correos provienen de:`,
        previewTipContacts: `Agrega esa dirección a tus contactos o libreta de direcciones.`,
        previewTipJunk: `Si no ves un correo después de un lanzamiento, revisa tu carpeta de spam o correo no deseado y márcalo como "No es spam".`,
        previewTipSafelist: `En una cuenta de trabajo, pide a tu administrador de TI que añada el dominio mangovoice.com a la lista de remitentes seguros.`,
      },
    },

    blockedNumberModal: {
      header: `Bloquear Número`,
      description: `Todas las llamadas, mensajes de texto y faxes de este número serán bloqueados.`,
      clearButton: `Borrar`,
      blockButton: `Bloquear Número`,
      inputPlaceholder: `Ingresar Número de Teléfono`,
      inputLabel: `Número de teléfono a bloquear`,
    },

    callCenterSettings: {
      enableAgentMode: `Habilitar Modo Agente`,
      customStatuses: `Estados de Agente Personalizados`,
      customStatusesDescription: `Configura estados personalizados para rastrear actividades fuera de la cola de llamadas, como almuerzos, descansos, reuniones y más. Mantén la actividad de tu equipo organizada y visible.`,
      editStatus: `Editar Estado`,
      deleteStatus: `Eliminar Estado`,
      confirmationModal: {
        title: `Eliminar Estado Personalizado`,
        text1: `Tu estado personalizado, `,
        text2: `, se eliminará permanentemente. ¿Estás seguro?`,
        confirmText: `Eliminar Estado`,
        cancelText: `Cancelar`,
      },
      newStatus: `Nuevo Estado`,
      toast: {
        deleteStatusSuccess: `Estado eliminado exitosamente`,
      },
    },

    customStatusModal: {
      NameAddrHeader: `Agregar Estado Personalizado`,
      editHeader: `Editar Estado Personalizado`,
      inputLabel: `Nombre del Estado`,
      inputPlaceholder: `Nombre`,
      type: `Tipo`,
      typePlaceholder: `Seleccionar Tipo`,
      away: `Ausente`,
      online: `En Línea`,
      description: `Descripción`,
      descriptionPlaceholder: `¿Para qué se usa este estado?`,
      toast: {
        createSuccess: `Estado creado exitosamente`,
        editSuccess: `Estado actualizado exitosamente`,
      },
      cancelButton: `Cancelar`,
      saveButton: `Guardar`,
    },

    experimentsState: {
      queueDashboardEnabled: `Panel de Cola`,
      queueDashboardDescription: `Habilitar la función del Panel de Cola.`,
      missedCallsEnabled: `Llamadas Perdidas`,
      missedCallsDescription: `Habilitar la función de seguimiento de llamadas perdidas.`,
      badge: {
        beta: `Versión Beta`,
      },
      globalPhoneCapture: {
        title: `Captura Global de Números de Teléfono`,
        description: {
          intro: `Te permite copiar un número de teléfono desde cualquier aplicación en tu computadora y luego presionar una tecla de acceso rápido para ingresar ese número en el teclado de marcación de Mango Voice.`,
          howToUse: `Cómo usar esta función: Primero elige la combinación de teclas de acceso rápido que deseas usar a continuación, luego presiona el botón "Establecer Tecla de Acceso Rápido".`,
          afterSet: `Una vez establecida tu tecla de acceso rápido, simplemente copia un número de teléfono como lo harías normalmente en cualquier otra aplicación (usando Cmd/Ctrl+C, o el menú contextual), luego presiona la tecla de acceso rápido elegida para cargar ese número en Mango Voice.`,
          note: `Nota: Algunas teclas de acceso rápido podrían estar en uso por otras aplicaciones; Mango intentará detectar cualquier conflicto y te lo hará saber.`,
        },
        activeSettingTitle: `Estado de la Tecla de Acceso Rápido:`,
        activeAndSet: `Tecla de Acceso Rápido Actual`,
        unsavedChanges: `Tecla de Acceso Rápido Propuesta:`,
        configureTitle: `Configurar Tecla de Acceso Rápido:`,
        keyLabel: `Tecla:`,
        status: {
          enabled: `Habilitado`,
          disabled: `Deshabilitado`,
        },
        button: {
          setHotkey: `Establecer Tecla de Acceso Rápido`,
          disableFeature: `Deshabilitar Tecla de Acceso Rápido`,
          enableFeature: `Habilitar Tecla de Acceso Rápido`,
          clearHotkey: `Limpiar Tecla de Acceso Rápido`,
        },
        notSet: `No establecido`,
        toast: {
          hotkeyCleared: `Tecla de acceso rápido limpiada`,
        },
      },
    },

    shortcutKeysHelp: {
      title: `Atajos de Teclado del Reproductor de Audio`,
      keyboardKeys: {
        spaceBar: `Barra Espaciadora`,
        m: `M`,
        leftArrow: `←`,
        rightArrow: `→`,
        slash: `/`,
        shift: `Mayús`,
      },
      playPause: `Reproducir / Pausar`,
      muteUnmute: `Silenciar / Activar sonido`,
      rewind10s: `Rebobinar 10s`,
      advance10s: `Avanzar 10s`,
      rewind3s: `Rebobinar 3s`,
      advance3s: `Avanzar 3s`,
      scopeNote: `Los atajos para silenciar y saltar funcionan mientras el foco del teclado está en el reproductor de audio.`,
    },

    newParkingLotModal: {
      header: `Agregar Lugar de Estacionamiento`,
      parkingSpot: `Lugar de Estacionamiento`,
      label: `Etiqueta`,
      cancelButton: `Cancelar`,
      saveButton: `Guardar`,
      parking1Label: `Estacionamiento 1`,
      parking2Label: `Estacionamiento 2`,
      parking3Label: `Estacionamiento 3`,
      parking4Label: `Estacionamiento 4`,
      parking5Label: `Estacionamiento 5`,
      parking6Label: `Estacionamiento 6`,
      parking7Label: `Estacionamiento 7`,
      parking8Label: `Estacionamiento 8`,
      parking9Label: `Estacionamiento 9`,
      parking10Label: `Estacionamiento 10`,
    },

    newExtensionSubscriptionModal: {
      header: `Agregar Presencia de Extensión`,
      extension: `Extensión`,
      cancelButton: `Cancelar`,
      saveButton: `Guardar`,
    },

    dropdownSelect: {
      placeholder: `Seleccionar...`,
      noResultsFound: `No se encontraron resultados`,
      assignUserFirst: `Primero asigne un usuario`,
    },

    tooltips: {
      filter: `Filtrar`,
      dismiss: `Descartar`,
      chartInformation: `Información del Gráfico`,
    },

    form: {
      placeholder: {
        searchNameOrNumber: `Buscar nombre o número`,
        selectStatus: `Seleccionar estado`,
        selectUser: `Seleccionar usuario`,
        selectVirtualFax: `Seleccionar fax virtual...`,
        searchNumbers: `Buscar números`,
        dateMonth: `MM`,
        dateDay: `DD`,
        dateYear: `AAAA`,
        timeHours: `HH`,
        timeMinutes: `MM`,
        timeMeridiem: `AM`,
      },
    },

    newSpeedDialModal: {
      addSpeedDial: `Agregar Marcación Rápida`,
      editSpeedDial: `Editar Marcación Rápida`,
      contactName: `Nombre del Contacto`,
      number: `Número`,
      cancelButton: `Cancelar`,
      saveButton: `Guardar`,
    },

    actionsButton: {
      tooltipNewAction: `Nueva Acción`,
      newThread: `Nuevo Hilo`,
      newCall: `Nueva Llamada`,
      newFax: `Nuevo Fax`,
    },

    accountButton: {
      settings: `Configuración`,
      connectionStatus: `Estado de la aplicación`,
      switchPbx: `Cambiar PBX`,
      openApp: `Abrir Aplicación`,
      downloadApp: `Descargar Aplicación`,
      whatsNew: `Novedades`,
      giveFeedback: `Dar Comentarios`,
      helpCenter: `Centro de Ayuda`,
      logOut: `Cerrar Sesión`,
      apiDocs: `Documentación API`,
    },

    statusPanel: {
      title: `Estado de la aplicación`,
      tabBasic: `Básico`,
      tabAdvanced: `Avanzado`,
      tabListLabel: `Vistas del estado de la aplicación`,
      refresh: `Actualizar`,
      refreshing: `Actualizando…`,
      refreshed: `Actualizado`,
      close: `Cerrar`,
      copyDiagnostics: `Copiar diagnóstico`,
      copied: `Copiado`,
      overallHealthy: `Correcto`,
      overallDegraded: `Degradado`,
      overallDown: `Caído`,
      overallIdle: `Inactivo`,
      overallUnknown: `Desconocido`,
      summaryGood: `Todo se ve bien.`,
      summaryProblem: `Encontramos un problema.`,
      fixNetworkOffline: `Comprueba tu Wi-Fi o el cable de red e inténtalo de nuevo.`,
      fixPhoneError: `Recarga la página para volver a conectar el teléfono. Si sigue fallando, contacta con soporte.`,
      fixRealtimeReconnecting: `Reconectando automáticamente. Si continúa, recarga la página.`,
      fixRealtimeSuspended: `La aplicación se pausó. Debería reanudarse en breve; recarga si no lo hace.`,
      fixRealtimeDisconnected: `Recarga la página para restaurar la mensajería y las actualizaciones de llamadas.`,
      rowInternet: `Internet`,
      rowPhoneService: `Servicio telefónico`,
      rowMessaging: `Mensajería`,
      rowAppUpdates: `Actualizaciones de la aplicación`,
      stateUpdateReady: `Actualización lista`,
      stateCantInstallUpdates: `No se pueden instalar actualizaciones`,
      stateUpdateBlocked: `Actualización bloqueada`,
      stateUpdateReadyVersion: `Actualización lista ({{version}})`,
      stateUpdateDownloading: `Descargando actualización…`,
      stateUpdateDownloadingVersion: `Descargando actualización ({{version}})…`,
      stateUpdateCheckFailed: `No se pudo buscar actualizaciones`,
      stateCheckingForUpdates: `Buscando actualizaciones…`,
      stateNotCheckedYet: `Aún no se ha comprobado`,
      checkAgain: `Volver a comprobar`,
      online: `En línea`,
      offline: `Sin conexión`,
      on: `Activado`,
      off: `Desactivado`,
      stateOnline: `En línea`,
      stateOffline: `Sin conexión`,
      stateConnected: `Conectado`,
      stateDisconnected: `Desconectado`,
      stateRegisteredReady: `Registrado y listo`,
      stateConnecting: `Conectando…`,
      stateReconnecting: `Reconectando`,
      stateSuspended: `Suspendido`,
      stateRegistrationError: `Error de registro`,
      regNotStarted: `No iniciado`,
      regRegistered: `Registrado`,
      regUnregistered: `No registrado`,
      regTerminated: `Finalizado`,
      transportNotStarted: `No iniciado`,
      transportConnected: `Conectado`,
      transportDisconnected: `Desconectado`,
      sectionSip: `SIP`,
      sectionMessaging: `Mensajería / tiempo real`,
      sectionNetwork: `Red`,
      sectionTelephony: `Telefonía`,
      sectionEnvironment: `Entorno`,
      labelRegistration: `Registro`,
      labelTransport: `Transporte`,
      labelLastError: `Último error`,
      labelWebSocket: `WebSocket`,
      labelLastHeartbeat: `Último latido`,
      heartbeatAgo: `hace {{seconds}} s`,
      heartbeatStale: `hace {{seconds}} s (obsoleto)`,
      heartbeatNone: `Ninguno aún`,
      labelReconnectAttempts: `Intentos de reconexión`,
      labelBrowser: `Navegador`,
      sectionAudio: `Audio`,
      labelMicPermission: `Permiso de micrófono`,
      labelMicInput: `Micrófono (entrada)`,
      labelSpeaker: `Altavoz (salida)`,
      deviceCount: `{{count}} encontrados`,
      deviceDefault: `Predeterminado del sistema`,
      deviceNone: `Ninguno detectado`,
      sectionCall: `Llamada activa`,
      callNone: `Sin llamada activa`,
      labelCallStatus: `Estado`,
      labelCallDirection: `Dirección`,
      labelCallSource: `Origen`,
      labelCallHold: `En espera`,
      labelCallMuted: `Silenciado`,
      labelCallDuration: `Duración`,
      labelLatestVersion: `Última versión`,
      labelUpToDate: `Actualizado`,
      labelOutOfDate: `Actualización disponible`,
      labelChannel: `Canal`,
      labelPlatform: `Plataforma`,
      sectionSession: `Sesión`,
      labelSignedIn: `Sesión iniciada`,
      labelTokenExpiry: `La sesión expira`,
      tokenExpired: `Expirada`,
      tokenValid: `Válida`,
      tokenNone: `Sin sesión activa`,
      labelNotifications: `Notificaciones`,
      labelLocalStorage: `Almacenamiento local`,
      storageWritable: `Escribible`,
      storageBlocked: `Bloqueado`,
      navChipDegraded: `Estado de la aplicación: requiere atención`,
      navChipDown: `Estado de la aplicación: se encontró un problema`,
      navChipAria: `Se detectó un problema. Abrir el estado de la aplicación.`,
      sectionEvents: `Eventos de conexión recientes`,
      noEvents: `Sin cambios de conexión en esta sesión: la conexión se ha mantenido estable.`,
      eventOnline: `Red en línea`,
      eventOffline: `Red sin conexión`,
      eventWsConnected: `Tiempo real conectado`,
      eventWsReconnecting: `Tiempo real reconectando`,
      eventWsSuspended: `Tiempo real suspendido`,
      eventWsDisconnected: `Tiempo real desconectado`,
      labelPbx: `PBX`,
      labelPbxId: `ID de PBX`,
      labelPbxUuid: `UUID de PBX`,
      labelDoNotDisturb: `No molestar`,
      labelRespondBusy: `Responder ocupado a 2.ª llamada`,
      labelAppVersion: `Versión de la app`,
      labelBuild: `Compilación`,
      labelCaptured: `Capturado`,
      labelUserAgent: `Agente de usuario`,
      extensions: `Extensiones`,
      noExtensions: `No hay extensiones asignadas.`,
      thisSession: `Esta sesión`,
    },

    contactsPage: {
      emptyDetailMessage: `Ningún Contacto Seleccionado`,
      toast: {
        copyNumberSuccess: `Número de teléfono copiado al portapapeles`,
        copyNumberError: `No se pudo copiar el número de teléfono`,
      },
    },

    contactsListView: {
      searchPlaceholder: `Buscar un nombre o número`,
      searchLabel: `Buscar contactos`,
      contactSourceContent: `Todos los Contactos`,
      emptyNotice: {
        noContactsYet: `Aún no hay contactos aquí`,
        contactSupport: `Contacta a nuestro equipo de soporte para conectar tus contactos de pacientes. Las extensiones internas también aparecerán aquí después de configurarlas en`,
        noContactsFound: `No se encontraron contactos`,
        noMatchingContacts: `No encontramos ningún contacto que coincida con`,
      },
    },

    contactItems: {
      primary: `Principal`,
      actionButton: {
        copyNumber: `Copiar Número`,
        callNumber: `Llamar Número`,
        messageNumber: `Enviar Mensaje de Texto al Número`,
        sendFax: `Enviar Fax`,
        callNumberLabel: `Llamar a {{number}}`,
        messageNumberLabel: `Enviar mensaje a {{number}}`,
        sendFaxLabel: `Enviar fax a {{number}}`,
        copyNumberLabel: `Copiar {{number}}`,
        unblockNumberLabel: `Desbloquear {{number}}`,
      },
      emptyContactItem: `No hay números de teléfono guardados para este contacto aún`,
      contactInformation: `Información de Contacto`,
      contactSource: `Fuente de Contacto:`,
      fromPms: `De {{pmsName}}`,
    },

    contactEventHistory: {
      recentActivity: `Actividad Reciente`,
      timespanText: `Últimos 14 Días`,
      historyLabel: {
        messaging: `Hilo de Mensajes`,
        inboundCall: `Llamada Entrante`,
        outboundCall: `Llamada Saliente`,
        inboundFax: `Fax Recibido`,
        outboundFax: `Fax Enviado`,
        voicemail: `Correo de Voz`,
      },
    },

    quickDialView: {
      tab: {
        favorites: `Favoritos`,
        recentlyDialed: `Marcados Recientemente`,
      },
      groupName: {
        parkingSpots: `Lugares de Estacionamiento`,
        lineExtensions: `Extensiones de Línea`,
        speedDial: `Marcación Rápida`,
      },
      phoneSettings: `Configuración del Teléfono`,
    },

    quickDialListItem: {
      empty: {
        parkingSpots: `Para mostrar lugares de estacionamiento aquí, ajusta la configuración de tu teléfono web`,
        lineExtensions: `Agrega cualquier extensión de línea para ver su disponibilidad aquí`,
        speedDial: `Guarda los números que llamas con frecuencia con marcación rápida`,
        recentlyDialedPrimary: `No hay Números Marcados Recientemente`,
        recentlyDialedSecondary: `Después de hacer llamadas, tus números marcados recientemente aparecerán aquí.`,
      },
      button: {
        webPhoneSettings: `Configuración del Teléfono Web`,
        configurePresence: `Configurar Presencia`,
        configureSpeedDial: `Configurar Marcación Rápida`,
      },
      parkingLot: {
        title: `Lugar de Estacionamiento`,
        subtitle: `Lugar de Estacionamiento`,
      },
      tooltip: {
        pickUpCall: `Responder llamada`,
        startCall: `Iniciar llamada`,
        parkCall: `Estacionar llamada`,
        newCall: `Iniciar una nueva llamada`,
        transferCall: `Transferir llamada`,
      },
    },

    callContactButton: {
      startCall: `Iniciar Llamada`,
      startCallAriaLabel: `Iniciar Llamada: {{name}}, {{number}}`,
      startCallNumberAriaLabel: `Iniciar Llamada: {{number}}`,
      callNumber: `Llamar al {{number}}`,
      callNumberWithLabel: `Llamar al {{number}} - {{label}}`,
      otherNumbersAriaLabel: `Otros números de {{name}}`,
    },

    phoneNumberInput: {
      placeholder: `Ingresar Número`,
      clearButton: `Borrar`,
      inputLabel: `Número de teléfono para llamar`,
    },

    phoneNumberMultiDropdown: {
      allNumbers: `Todos los Números`,
    },

    phoneSearchInput: {
      placeholder: `Ingresar Nombre o Número`,
      clearButton: `Borrar`,
      inputLabel: `Buscar por nombre o número`,
    },

    contactCardsList: {
      emptySearchText: `Ingresa un nombre o número arriba para iniciar una búsqueda`,
    },

    outOfCallView: {
      tabButtonDialpad: `Teclado`,
      tabButtonSearch: `Buscar`,
    },

    contactCardList: {
      searchResults: `Resultados de Búsqueda`,
      noMatchingContacts: `No encontramos ningún contacto que coincida con `,
    },

    callButton: {
      startCall: `Iniciar Llamada`,
      endCall: `Finalizar Llamada`,
      disabled: `Deshabilitado`,
      unknown: `Desconocido`,
    },

    callControlButton: {
      endCall: `Finalizar Llamada`,
      splitConference: `Dividir Conferencia`,
      mergeCalls: `Fusionar Llamadas`,
      newCall: `Nueva Llamada`,
      transfer: `Transferir`,
      park: `Estacionar`,
      mute: `Silenciar`,
      keypad: `Teclado`,
      hold: `Poner en Espera`,
      audioSettings: `Configuración de Audio`,
    },

    onboardingView: {
      welcomeText: `Realiza Llamadas Desde Cualquier Navegador`,
      bodyText: `Realiza y recibe llamadas, transfiere o estaciona con facilidad, gestiona múltiples llamadas, añade favoritos y marcaciones rápidas. Tu comunicación, a tu manera, desde cualquier lugar.`,
      buttonLabel: `Activar Teléfono`,
      confirmModal: {
        title: `No hay Extensiones de Línea Disponibles`,
        message1: `No tienes extensiones de línea asignadas en este sistema telefónico {{pbxName}}.`,
        message2: `Para usar la función de teléfono, contacta a tu administrador de sistema para asignar una extensión de línea.`,
        confirmText: `Descartar`,
      },
    },

    numberComparisonDashboard: {
      invalidDateRange: `Rango de fecha inválido`,
      dateRangeTooLarge: `El rango de fechas es demasiado grande. Por favor seleccione un rango de 365 días o menos.`,
      dateRangeAdjustPrompt: `Por favor ajuste su rango de fechas e intente nuevamente.`,
      chartTitle: `Volumen de llamadas por número`,
      showingCount: `Mostrando {{displayed}} de {{total}}`,
      showMore: `Mostrar más ({{remaining}} restantes)`,
      unknown: `Desconocido`,
      notAvailable: `N/D`,
      counters: {
        totalCalls: {
          title: `Total de llamadas entrantes`,
          subtitle: `Total de llamadas entrantes en todos los números`,
        },
        numberCount: {
          title: `Total de números`,
          subtitle: `Total de números de teléfono rastreados`,
        },
        averageCalls: {
          title: `Promedio por número`,
          subtitle: `Promedio de llamadas entrantes por número`,
        },
        topNumber: {
          title: `Mejor rendimiento`,
        },
      },
      dashboard: {
        errorText: `Error al cargar datos de número`,
        noDataText: `No hay datos de número disponibles`,
      },
    },

    callControl: {
      audioSettings: {
        title: `Configuración de Audio`,
        outputSource: `Fuente de Salida - Altavoces`,
        inputSource: `Fuente de Entrada - Micrófono`,
      },
      parkCall: `Estacionar Llamada`,
      transferCall: `Transferir Llamada`,
    },

    transferTarget: {
      buttonText: `Transferir Llamada`,
      buttonAriaLabel: `Transferir Llamada: {{name}}, {{number}}`,
    },

    transferHeader: {
      placeholder: `Ingresar Número`,
      ariaLabel: `Transferir`,
      inputLabel: `Transferir al número`,
    },

    parkTarget: {
      buttonText: `Estacionar Llamada`,
      buttonAriaLabel: `Estacionar Llamada: {{name}}`,
    },

    controlDrawer: {
      ariaLabel: `Cerrar Cajón`,
    },

    dashboardsPage: {
      item: {
        agentStatus: `Estado del Agente`,
        eventLog: `Registro de Eventos`,
        inboundAnswerRate: `Tasa de Respuesta Entrante`,
        numberComparison: `Comparación de Números`,
        extensionComparison: `Comparación de Extensiones`,
        queueDashboard: `Panel de Cola`,
      },
      group: {
        callCenter: `Centro de Llamadas`,
        callDashboards: `Paneles de Llamadas`,
      },
    },

    queueDashboard: {
      emptyState: {
        title: `No se encontró información`,
        description: `Seleccione una cola de la lista para ver datos relevantes`,
      },
      filters: {
        title: `Cola`,
        subtitle: `Vea cómo se compara la actividad de llamadas de su equipo`,
      },
      queueSelector: {
        placeholder: `Seleccionar de la lista`,
        ariaLabel: `Seleccionar una cola de llamadas`,
      },
      metrics: {
        callersInQueue: `Llamadas en Cola`,
        maxWait: `Tiempo de Espera Máximo`,
        averageWait: `Tiempo de Espera Promedio`,
        maxAbandoned: `Máximo Abandonado`,
        averageAbandoned: `Promedio Abandonado`,
        dropRate: `Tasa de Abandono`,
        answerRate: `Tasa de Respuesta`,
        sampleHistory: `Historial de Muestra`,
        sampleHistoryAriaLabel: `Seleccionar ventana de tiempo del historial de muestra`,
      },
      agentsPanel: {
        title: `Cola de Agentes`,
        activeAgents: `Agentes Activos`,
        inactiveAgents: `Agentes Inactivos`,
        searchPlaceholder: `Ingrese nombre o extensión`,
        exportCsv: `Exportar CSV`,
        exportToast: {
          title: `Exportar`,
          description: `La funcionalidad de exportación CSV estará disponible pronto.`,
        },
        loginFailed: {
          title: `Error de Inicio de Sesión`,
          description: `No se pudo iniciar sesión del agente en la cola. Por favor, intente nuevamente.`,
        },
        logoutFailed: {
          title: `Error de Cierre de Sesión`,
          description: `No se pudo cerrar sesión del agente de la cola. Por favor, intente nuevamente.`,
        },
      },
      callersTable: {
        title: `Cola Entrante`,
        callerNumber: `Número de Llamada`,
        callerName: `Nombre del Llamante`,
        callTime: `Tiempo de Llamada / Espera`,
        status: `Estado`,
        emptyState: {
          title: `No se encontró información`,
          description: `Actualmente no hay información que mostrar para la Cola actual`,
        },
      },
      activeAgentsTable: {
        callerNumber: `Número de Llamada`,
        agentName: `Nombre del Agente`,
        ext: `Ext`,
        loggedIn: `Conectado`,
        talkTime: `Tiempo de Conversación`,
        answered: `Respondidas`,
        missed: `Perdidas`,
        total: `Total`,
        status: `Estado`,
        lastOffered: `Última Oferta`,
        action: `Acción`,
        emptyState: {
          title: `No se encontraron Agentes`,
          description: `Actualmente no hay información que mostrar para la Cola actual`,
        },
      },
      inactiveAgentsTable: {
        agent: `Agente`,
        ext: `Ext`,
        lastLoggedOut: `Última Desconexión`,
        status: `Estado`,
        action: `Acción`,
        emptyState: {
          title: `No se encontraron Agentes`,
          description: `Actualmente no hay información que mostrar para la Cola actual`,
        },
      },
      agentRow: {
        changeStatus: `Cambiar Estado`,
        offline: `Desconectado`,
      },
      settings: {
        alertHoldTime: `Tiempo de Alerta en Espera`,
        alertHoldTimeAriaLabel: `Seleccionar umbral de alerta de espera`,
        refreshEvery: `Actualizar cada`,
        refreshAriaLabel: `Seleccionar intervalo de actualización`,
        seconds_one: `{{count}} segundo`,
        seconds_other: `{{count}} segundos`,
        minutes_one: `{{count}} min`,
        minutes_other: `{{count}} min`,
        hours_one: `{{count}} hr`,
        hours_other: `{{count}} hr`,
      },
      errorDisplay: {
        retrying_one: `Reintentando en {{count}} segundo...`,
        retrying_other: `Reintentando en {{count}} segundos...`,
        retryNow: `Reintentar Ahora`,
        retryingButton: `Reintentando...`,
        persistentMessage: `La actualización automática se ha pausado debido a fallos repetidos.`,
      },
      status: {
        ready: `Listo`,
        onCall: `En Llamada`,
        ringing: `Sonando`,
        available: `Disponible`,
        break: `Descanso`,
        waiting: `Esperando`,
        answered: `Respondida`,
        cancelled: `Cancelada`,
      },
    },

    inboundAnswerRate: {
      header: `Tasa de Respuesta Entrante`,
      subtitle: `Muestra el porcentaje de llamadas entrantes contestadas`,
      filters: {
        dateRange: `Rango de Fechas`,
        number: `Número`,
        maxPhoneNumbers: `(máx {{max}})`,
      },
      counters: {
        answerRate: {
          title: `Tasa de Respuesta`,
          subtitle: `Porcentaje de llamadas contestadas`,
        },
        totalCalls: {
          title: `Total de Llamadas`,
          subtitle: `Total de llamadas entrantes`,
        },
        answered: {
          title: `Llamadas Contestadas`,
          subtitle: `Total de llamadas contestadas`,
        },
        missed: {
          title: `Llamadas Perdidas`,
          subtitle: `Total de llamadas perdidas`,
        },
      },
      dashboard: {
        title: `Estadísticas de Tasa de Respuesta`,
        errorText: `Error al cargar los datos de llamadas`,
        noDataText: `No hay datos de llamadas disponibles`,
        tableViewPlaceholder: `Vista de tabla próximamente`,
      },
      metrics: {
        answered: `Contestadas`,
        missed: `Perdidas`,
        answerRate: `Tasa de Respuesta`,
      },
      rechartTitle: `Llamadas por {{groupByTitle}}`,
      viewToggle: {
        chart: `Gráfico`,
        table: `Tabla`,
      },
      table: {
        errorLoading: `Error al cargar estadísticas de números de teléfono`,
        noData: `No hay datos de números de teléfono disponibles`,
        unknown: `Desconocido`,
        columns: {
          number: `Número`,
          answerRate: `Tasa de Respuesta Entrante`,
          answered: `Llamadas Contestadas`,
          missed: `Llamadas Perdidas`,
          total: `Total de Llamadas`,
        },
      },
      invalidDateRange: `Rango de fecha inválido`,
      dateRangeTooLarge: `El rango de fechas es demasiado grande. Por favor seleccione un rango de 365 días o menos.`,
      dateRangeAdjustPrompt: `Por favor ajuste su rango de fechas e intente nuevamente.`,
    },

    voicemailLineChart: {
      rechartTitle: `Correos de Voz por {{groupByTitle}}`,
    },

    agentStatusFilters: {
      header: `Estado del Agente`,
      availability: `Disponibilidad`,
      status: `Estado`,
      items: {
        online: `En Línea`,
        away: `Ausente`,
      },
    },

    agentStatusTable: {
      agent: `Agente`,
      extension: `Extensión`,
      currentStatus: `Estado Actual`,
      timeInStatus: `Tiempo en Estado`,
      startedAt: `Iniciado el`,
      actions: `Acciones`,
      status: {
        offline: `Desconectado`,
        inQueue: `En Cola`,
      },
    },

    agentStatusActions: {
      tooltip: {
        changeStatus: `Cambiar Estado`,
      },
    },

    eventLog: {
      title: `Registro de Eventos`,
      filters: {
        allAgents: `Todos los Agentes`,
        searchAgents: `Buscar agentes`,
      },
    },

    eventLogTable: {
      when: `Cuándo`,
      who: `Quién`,
      status: `Estado`,
      inQueue: `En Cola`,
      changedBy: `Cambiado por`,
      yes: `Sí`,
      no: `No`,
      system: `Sistema`,
      unknown: `Desconocido`,
      failedToLoad: `No se pudieron cargar más eventos.`,
      retry: `Reintentar`,
      noRecords: `No se encontraron registros.`,
      noRecordsHint: `Intenta ajustar o borrar los filtros para ver más.`,
    },

    callDetailsOverviewTab: {
      missed: `Perdida`,
      answered: `Contestada`,
      textButton: `Correo de Voz Grabado`,
    },

    callDetailData: {
      missed: `Perdida`,
      answered: `Contestada`,
      inProgress: `En Curso`,
      failed: `Fallida`,
      direction: {
        inbound: `Entrante`,
        outbound: `Saliente`,
        internal: `Interna`,
      },
    },

    callFilters: {
      buttonTitle: `Filtro`,
      sections: {
        direction: `Dirección`,
        outcome: `Resultado`,
        sentiment: `Sentimiento`,
        status: `Estado`,
        callTrait: `Característica de Llamada`,
        duration: `Duración`,
        user: `Usuario`,
        aiAgent: `Agente de IA`,
      },
      direction: {
        inbound: `Entrante`,
        outbound: `Saliente`,
        internal: `Interna`,
      },
      outcome: {
        missed: `Perdida`,
        answered: `Contestada`,
      },
      sentiment: {
        office: `Oficina`,
        patient: `Paciente`,
        negative: `Negativo`,
        neutral: `Neutral`,
        positive: `Positivo`,
      },
      status: {
        inProgress: `En Curso`,
        completed: `Completada`,
        failed: `Fallida`,
        canceled: `Cancelada`,
        busy: `Ocupada`,
      },
      callTrait: {
        voicemailRecorded: `Correo de Voz Grabado`,
        externallyTransferred: `Transferida Externamente`,
      },
      duration: {
        longerThan: `Más Larga Que`,
        shorterThan: `Más Corta Que`,
        tenSeconds: `10 segundos`,
        oneMinute: `1 minuto`,
        fiveMinutes: `5 minutos`,
        tenMinutes: `10 minutos`,
      },
      user: {
        unknown: `Usuario Desconocido`,
      },
      aiAgent: {
        unknown: `Agente de IA Desconocido`,
      },
    },

    rechartsBarChart: {
      tooltip: {
        modalView: `Vista Modal`,
        answerRate: `Tasa de respuesta:`,
        total: `Total:`,
      },
      noChartData: `No hay datos de gráficos disponibles`,
      weekOf: `Semana del {{date}}`,
    },

    dateDropdown: {
      today: `Hoy`,
      yesterday: `Ayer`,
      last7Days: `Últimos 7 Días`,
      last14Days: `Últimos 14 Días`,
      last30Days: `Últimos 30 Días`,
      thisWeek: `Esta Semana`,
      lastWeek: `La Semana Pasada`,
      thisMonth: `Este Mes`,
      lastMonth: `El Mes Pasado`,
      last60Days: `Últimos 60 Días`,
      last90Days: `Últimos 90 Días`,
      customRange: `Rango Personalizado`,
    },

    dateTimeRange: {
      after: `Después de: {{date}}`,
      before: `Antes de: {{date}}`,
      selectDateRange: `Seleccionar Rango de Fechas`,
      buttonPlaceholder: `Seleccionar Rango de Fechas`,
    },

    dateTimeRangeModal: {
      after: `Después de `,
      before: `Antes de `,
      optional: `(opcional)`,
      selectDateRange: `Seleccionar Rango de Fechas`,
      buttonPlaceholder: `Seleccionar Rango de Fechas`,
      clearButton: `Borrar`,
      setDateRangeButton: `Establecer Rango de Fechas`,
      monthLabel: `{{label}}: mes`,
      dayLabel: `{{label}}: día`,
      yearLabel: `{{label}}: año`,
      hourLabel: `{{label}}: hora`,
      minuteLabel: `{{label}}: minuto`,
      meridiemLabel: `{{label}}: a. m./p. m.`,
    },

    queueControlButton: {
      inQueue: `En cola`,
      outOfQueue: `Fuera de cola`,
      doNotDisturb: `No molestar`,
      online: `En línea`,
      offline: `Fuera de línea`,
      joinQueue: `Entrar en cola`,
      leaveQueue: `Salir de cola`,
      goOffline: `Fuera de línea`,
    },

    queueStatusMenu: {
      online: `En línea`,
      away: `Ausente`,
      goOffline: `Fuera de línea`,
      joinQueue: `Entrar en cola`,
    },

    changelogModal: {
      whatsNewLabel: `Novedades`,
      noResults: `No hay registro de cambios disponible`,
      doneButton: `Hecho`,
      loadingData: `Cargando registro de cambios...`,
      latest: `(Más reciente)`,
      releasedLabel: `Lanzado`,
    },

    queueToasts: {
      loggedInToQueue: `Conectado a la cola`,
      loggedOutOfQueue: `Desconectado de la cola`,
      agentStatusUpdated: `Estado del agente actualizado`,
      unableToUpdateStatus: `No se puede actualizar el estado`,
      queueUpdateErrorMessage: `Por favor asegúrate de que este Usuario/Extensión esté agregado a una Cola de Llamadas en el Portal de Administración o contacta a Soporte.`,
      genericUpdateErrorMessage: `Algo salió mal al actualizar el estado. Inténtalo de nuevo o contacta a Soporte.`,
      ok: `OK`,
    },

    regionSelector: {
      settingsTitle: `Región de Datos de Mango`,
      settingsDescription: `Esto indica la región donde se mantienen tus datos dentro del ecosistema de Mango.`,
      selectRegion: `Seleccionar Región`,
      regionInfoTooltip: `Representa la Región de Datos de Mango, no tu ubicación.`,
      regions: {
        unitedStates: `Estados Unidos`,
        unitedKingdom: `Reino Unido`,
      },
    },

    announcementBanner: {
      infoLabel: `Anuncio informativo: {{title}}`,
      warningLabel: `Anuncio de advertencia: {{title}}`,
      criticalLabel: `Anuncio crítico: {{title}}`,
      dismiss: `Descartar anuncio`,
      collapse: `Contraer anuncio`,
      expand: `Expandir anuncio`,
    },
    bannerPager: {
      carousel: `Avisos`,
      slide: `Aviso {{current}} de {{total}}`,
      position: `{{current}}/{{total}}`,
      previous: `Aviso anterior`,
      next: `Siguiente aviso`,
      carouselRole: `carrusel`,
      slideRole: `diapositiva`,
    },

    appVersionBanner: {
      desktopUpdateAvailable: `¡La versión {{version}} de {{appName}} está disponible!`,
      webUpdateAvailable: `¡Una nueva versión de la Aplicación Web Mango está disponible!`,
      restartAndUpdate: `Reiniciar y Actualizar`,
      updateNow: `Actualizar Ahora`,
      whatsNew: `Novedades`,
      remindLater: `Recordármelo más tarde`,
      dismiss: `Descartar`,
    },

    clockSkewBanner: {
      message: `El reloj de tu dispositivo tiene un desfase de más de unos minutos. Esto puede hacer que las llamadas, los mensajes y otras funciones se comporten de forma inesperada. Activa la sincronización automática de fecha y hora en la configuración de tu sistema.`,
    },

    updateBlockedBanner: {
      message: `La aplicación no pudo completar la actualización. Esto suele deberse a que un antivirus o software de seguridad está bloqueando la actualización. Pide a tu equipo de TI que permita que la aplicación se actualice, o descarga la última versión.`,
      downloadLatest: `Descargar la última versión`,
    },

    updatePermissionBanner: {
      message: `La aplicación no puede instalar actualizaciones en esta computadora debido a la forma en que se instaló. Sigue nuestro artículo de ayuda o compártelo con tu equipo de TI.`,
      howToFix: `Cómo solucionarlo`,
      updateAnyway: `Actualizar de todos modos`,
    },

    updateCheck: {
      checkForUpdates: `Buscar Actualizaciones`,
      restartAndUpdate: `Reiniciar y Actualizar`,
      checking: `Buscando actualizaciones...`,
      upToDate: `La aplicación está actualizada`,
      checkFailed: `Error al buscar actualizaciones`,
      versionAvailable: `La versión {{version}} está disponible`,
      downloading: `Descargando... {{percent}}%`,
      downloaded: `Versión {{version}} descargada`,
      errorOccurred: `Ocurrió un error al buscar actualizaciones.`,
    },
    updateRequirement: {
      recommendedMessage: `Hay una nueva versión de {{appName}} disponible. Actualiza para obtener las últimas correcciones.`,
      recommendedMessageWithDate: `Actualiza {{appName}} antes del {{date}} para seguir usándola.`,
      requiredDuringCall: `Esta versión de {{appName}} ya no es compatible. Cuando termine tu llamada, deberás actualizar para continuar.`,
      update: `Actualizar`,
      later: `Más tarde`,
      downloading: `Descargando {{percent}}%`,
      restartToUpdate: `Reiniciar para actualizar`,
      downloadInstaller: `Descargar instalador`,
      requiredTitle: `Actualización necesaria`,
      requiredMessage: `Esta versión de {{appName}} ({{currentVersion}}) ya no es compatible. Actualiza para seguir usando la aplicación.`,
      callsNotice: `Hasta que actualices, esta aplicación no puede recibir llamadas. Las llamadas se dirigen a tus otros dispositivos, grupos de timbrado o buzón de voz.`,
      preparing: `Preparando la actualización...`,
      downloadingProgress: `Descargando la actualización: {{percent}}%`,
      progressLabel: `Progreso de descarga de la actualización`,
      manualInstallMessage: `La aplicación no puede instalar la actualización automáticamente. Descarga e instala la versión más reciente.`,
      useWebApp: `Usar la aplicación web`,
      contactSupport: `Contactar con soporte`,
      alertTitle: `{{appName}} necesita una actualización`,
      alertBody: `Las llamadas se dirigen a otros dispositivos o al buzón de voz hasta que actualices.`,
      copyDownloadLink: `Copiar enlace de descarga`,
      linkCopied: `Enlace copiado`,
    },

    callDetails: {
      title: `Detalles de la Llamada`,
      callTimeline: `Línea de Tiempo de la Llamada`,
      callFlow: `Flujo de la Llamada`,
      started: `Iniciada`,
      ended: `Finalizada`,
      answerTime: `Tiempo de Respuesta`,
      callDuration: `Duración de la Llamada`,
      callOn: `Llamada del`,
      statisticsNotAvailable: `Las estadísticas no están disponibles`,
      transcriptNotAvailable: `La transcripción no está disponible`,
      noRecordingAvailable: `No hay grabación disponible`,
      callSummary: `Resumen de la Llamada`,
      callStatistics: `Estadísticas de la Llamada`,
      header: {
        copyLinkToCall: `Copiar Enlace a la Llamada`,
        copyLinkToCallAtTimestamp: `Copiar Enlace a la Llamada en el Timestamp`,
        downloadAudio: `Descargar audio`,
        closePanel: `Cerrar Panel`,
        expand: `Expandir`,
        moreActions: `Más Acciones`,
      },
      sections: {
        sentimentByQuarter: {
          title: `Sentimiento por Cuarto`,
          tooltip: `Esto muestra el sentimiento del paciente y la oficina, reflejando el tono emocional de la conversación. Cada cuarto se clasifica como positivo (verde), neutral (gris) o negativo (rojo).`,
          agentOverall: `Agente: {{score}} General`,
          customerOverall: `Cliente: {{score}} General`,
          patient: `Paciente`,
          office: `Oficina`,
        },
        officeTalkTime: {
          title: `Tiempo de Habla de la Oficina`,
          tooltip: `Este gráfico circular muestra un desglose del tiempo que la oficina pasó hablando versus escuchando durante la llamada. Idealmente, los agentes deben pasar más tiempo escuchando que hablando, apuntando a una división de 50-60% hablando y 40-50% escuchando para una interacción efectiva con el cliente.`,
          talking: `Hablando`,
          listening: `Escuchando`,
        },
        officeTalkSpeed: {
          title: `Velocidad de Habla de la Oficina`,
          tooltip: `Esto muestra la velocidad general de habla de la oficina en palabras por minuto (ppm). Un rango normal es de 120-150 ppm, que es claro y fácil de entender. Las velocidades por debajo de 100 ppm pueden sentirse demasiado lentas, mientras que las velocidades por encima de 160 ppm pueden ser difíciles de seguir para los pacientes.`,
          wordsPerMinute: `Palabras Por Minuto`,
        },
        interruptions: {
          title: `Interrupciones`,
          tooltip: `Esto muestra un desglose de cuántas veces el paciente y la oficina se interrumpieron mutuamente. Es útil para evaluar qué tan fluida fue la conversación.`,
          total: `Total`,
          patient: `Paciente`,
          office: `Oficina`,
        },
        holdAndPauseTime: {
          title: `Tiempo en Espera y Pausas`,
          tooltip: `Esto muestra cuánto tiempo pasó el llamante en espera o en silencio, y el porcentaje de la llamada total. Los tiempos de espera más largos de lo normal se resaltan en rojo.`,
          percentageOfCall: `{{percentage}}% de la llamada`,
        },
      },
      toast: {
        linkCopied: `Enlace Copiado al Portapapeles`,
        linkCopyFailed: `No se pudo copiar el enlace al portapapeles.`,
        voicemailTranscriptCopied: `Transcripción del correo de voz copiada al portapapeles.`,
        voicemailTranscriptCopyFailed: `No se pudo copiar la transcripción del correo de voz.`,
        noVoicemailTranscript: `No hay transcripción de correo de voz para copiar.`,
        voicemailTranscriptCopyError: `No se pudo copiar la transcripción del correo de voz. Por favor, inténtalo de nuevo.`,
        summaryCopied: `Resumen copiado al portapapeles.`,
        summaryCopyFailed: `No se pudo copiar el resumen. Por favor, inténtalo de nuevo.`,
        noSummary: `No hay resumen para copiar.`,
        feedbackThanks: `¡Gracias por tus comentarios!`,
        feedbackThumbsUpFailed: `No se pudo reportar la acción de Me Gusta.`,
        feedbackThumbsDownFailed: `No se pudo reportar la acción de No Me Gusta.`,
      },
      voicemail: {
        title: `Correo de Voz`,
        loading: `Cargando transcripción del correo de voz...`,
        accessDenied: `Este correo de voz fue dejado en una bandeja de entrada a la que no tienes acceso. Contacta a tu administrador del sistema.`,
        deleted: `El correo de voz ha sido eliminado.`,
        notAvailable: `Correo de voz no disponible.`,
        transcriptionNotAvailable: `Transcripción del correo de voz no disponible.`,
      },
      summary: {
        title: `Resumen`,
        processing: `Procesando transcripción de la llamada...`,
        notFound: `No se encontró resumen`,
        notAvailable: `No hay resumen de transcripción disponible.`,
      },
      margoSummary: {
        title: `Resumen de Margo`,
        copy: `Copiar el resumen de Margo`,
        copied: `Resumen de Margo copiado`,
        copySuccess: `Resumen de Margo copiado al portapapeles.`,
        copyFailure: `No se pudo copiar el resumen de Margo. Inténtalo de nuevo.`,
      },
      tabs: {
        overview: `Resumen`,
        transcripts: `Transcripciones`,
        stats: `Estadísticas`,
      },
      sentiment: {
        title: `Sentimiento`,
        patient: `Paciente`,
        office: `Oficina`,
        positive: `Positivo`,
        negative: `Negativo`,
        neutral: `Neutral`,
      },
      tooltip: {
        copyToClipboard: `Copiar al portapapeles`,
        goToVoicemail: `Ir al correo de voz`,
        accurate: `Preciso`,
        inaccurate: `Impreciso`,
        copyLinkToSearch: `Copiar Enlace a la Búsqueda`,
        fullscreen: `Pantalla completa`,
      },
    },

    calls: {
      searchLabel: `Buscar llamadas`,
      export: {
        button: `Exportar CSV`,
        starting: `Iniciando...`,
        preparing: `Preparando exportación...`,
        processing: `Exportando...`,
        completed: `Exportado`,
        success: `La descarga del CSV ha comenzado`,
        successTruncated: `Exportación completa (resultados truncados a 1M de filas)`,
        error: `Error en la exportación`,
        errorTooMany: `Demasiadas exportaciones en ejecución. Espere e intente de nuevo.`,
        errorInvalid: `Parámetros de exportación no válidos.`,
        errorNotFound: `Exportación no encontrada. El servidor puede haberse reiniciado. Intente de nuevo.`,
        errorGeneric: `No se pudo iniciar la exportación.`,
        errorStatusCheck: `No se pudo verificar el estado de la exportación.`,
        toastProcessingTitle: `Exportación en progreso`,
        toastProcessingDescription: `Su CSV se está preparando. La descarga comenzará automáticamente.`,
        unsupportedFiltersHeader: `La exportación CSV no admite estos filtros:`,
        filterSearch: `Búsqueda`,
      },
      transcriptCell: {
        noTranscriptAvailable: `No hay transcripción disponible.`,
        inProgress: `La transcripción se está generando, vuelve a consultar más tarde.`,
        audioTooLong: `Transcripción no disponible: el audio de la llamada era demasiado largo.`,
        viewTranscript: `Ver transcripción`,
        noTranscript: `No hay transcripción disponible`,
        transcriptInProgress: `Transcripción en curso`,
        transcriptUnavailable: `Transcripción no disponible`,
        openVoicemail: `Abrir correo de voz`,
      },
      detail: {
        notFound: `Vaya, este registro se eliminó o no existe. Si necesitas ayuda, contacta a soporte.`,
        unknownNumber: `Número desconocido`,
        unknownSource: `Desconocido`,
      },
    },

    missedCalls: {
      emptyState: `Sin llamadas perdidas`,
      emptyStateSubtitle: `Todas las llamadas han sido contestadas`,
      description: `Rastrear y gestionar llamadas perdidas`,
      instructions: `Usa filtros y rangos de fechas para encontrar llamadas perdidas específicas`,
      errorLoadingMissedCalls: `Error al cargar llamadas perdidas`,
      pleaseTryAgainLater: `Por favor, inténtelo más tarde`,
      countLabel: `{{count}} Llamadas Perdidas`,
      refresh: `Actualizar`,
      followUpStatus: {
        open: `Abierto`,
        returnedCallBack: `Devuelto - Llamar de vuelta`,
        returnedSMS: `Devuelto - SMS`,
        returnedVoicemail: `Devuelto - Correo de voz`,
        returnedEmail: `Devuelto - Correo electrónico`,
        returnedNoAnswer: `Devuelto - Sin respuesta`,
        noFollowUpRequired: `No se requiere seguimiento`,
        assignUserFirst: `Asignar un usuario primero`,
      },
      filters: {
        sections: {
          type: `Tipo`,
          status: `Estado`,
          user: `Usuario`,
          phoneNumber: `Número de teléfono`,
        },
        type: {
          voicemail: `Correo de voz`,
          abandoned: `Abandonada`,
        },
        userFallback: `Usuario {{id}}`,
      },
      assignedUser: {
        loading: `Cargando...`,
        loadingShort: `Cargando`,
        unassigned: `Sin asignar`,
        userFallback: `Usuario {{id}}`,
      },
      type: {
        voicemailAlt: `Correo de voz`,
        abandonedAlt: `Abandonada`,
        abandonedTitle: `Abandonada`,
        abandonedDescription: `La llamada no fue contestada y el cliente no dejó un correo de voz`,
      },
    },

    callsList: {
      noCallsFound: `No se encontraron llamadas`,
      tryDifferentFilters: `Prueba con diferentes filtros`,
    },

    callsTable: {
      label: `Llamadas`,
      openCallDetails: `Ver detalles de la llamada, {{time}} {{date}}`,
      columns: {
        dateTime: `Fecha y Hora`,
        outcome: `Resultado`,
        to: `Para`,
        from: `De`,
        toFrom: `Para/De`,
        duration: `Duración`,
        transcript: `Transcripción`,
      },
    },

    missedCallsTable: {
      columns: {
        dateTime: `Fecha y Hora`,
        from: `De`,
        to: `Para`,
        type: `Tipo`,
        followUpTime: `Tiempo de Seguimiento`,
        followUpStatus: `Estado de Seguimiento`,
        assignedTo: `Asignado a`,
        action: `Acción`,
      },
    },

    contactInfoCard: {
      callTarget: {
        from: `De`,
        to: `Para`,
      },
      tooltip: {
        call: `Llamar`,
        message: `Mensaje`,
        sendFax: `Enviar Fax`,
        blockNumber: `Bloquear Número`,
        unblockNumber: `Desbloquear Número`,
      },
    },

    contactCell: {
      menu: {
        callNumber: `Llamar Número`,
        copyNumber: `Copiar Número`,
        messageNumber: `Mensaje Número`,
        sendFax: `Enviar Fax`,
        blockNumber: `Bloquear Número`,
        unblockNumber: `Desbloquear Número`,
        moreOptions: `Más opciones`,
        moreOptionsFor: `Más opciones para {{name}}, {{time}} {{date}}`,
      },
    },

    reportingFilters: {
      dateRange: `Rango de fecha`,
      number: `Número`,
      maxPhoneNumbers: `(máx {{max}})`,
    },

    numberComparisonFilters: {
      numberComparison: `Comparación de números`,
      subtitle: `Comparar volumen de llamadas entrantes entre números de teléfono`,
      dateRange: `Rango de fecha`,
      number: `Número`,
      maxPhoneNumbers: `(máx {{max}})`,
    },

    numberComparisonTable: {
      columns: {
        name: `Nombre del número de teléfono`,
        number: `Número de teléfono`,
        inboundCalls: `Llamadas entrantes`,
        avgDuration: `Duración promedio`,
      },
    },

    numberComparisonChart: {
      inboundCalls: `Llamadas entrantes`,
      avgDuration: `Duración promedio`,
    },

    extensionComparison: {
      retired: `Retirado`,
    },

    extensionComparisonDashboard: {
      invalidDateRange: `Rango de fecha inválido`,
      dateRangeTooLarge: `El rango de fechas es demasiado grande. Por favor seleccione un rango de 365 días o menos.`,
      dateRangeAdjustPrompt: `Por favor ajuste su rango de fechas e intente nuevamente.`,
      chartTitle: `Volumen de llamadas por extensión`,
      showingCount: `Mostrando {{displayed}} de {{total}}`,
      notAvailable: `N/D`,
      counters: {
        totalCalls: {
          title: `Total de llamadas`,
          subtitle: `Total de llamadas en todas las extensiones`,
        },
        averageCalls: {
          title: `Promedio por extensión`,
          subtitle: `Promedio de llamadas por extensión`,
        },
        averageMinutes: {
          title: `Minutos promedio por extensión`,
          subtitle: `Promedio de minutos por extensión`,
        },
        topExtension: {
          title: `Mejor rendimiento`,
        },
      },
      dashboard: {
        errorText: `Error al cargar datos de extensión`,
        noDataText: `No hay datos de extensión disponibles`,
      },
    },

    extensionComparisonFilters: {
      title: `Comparación de Extensiones`,
      subtitle: `Comparar volumen de llamadas entre extensiones`,
      directionLabel: `Dirección`,
      extensionsLabel: `Extensiones`,
      direction: {
        all: `Entrante y Saliente`,
        inbound: `Entrante`,
        outbound: `Saliente`,
      },
    },

    extensionComparisonChart: {
      extensionLabel: `Extensión {{ext}}`,
      totalCalls: `Total de llamadas`,
      totalMinutes: `Total de minutos`,
      avgDuration: `Duración promedio`,
      showMore: `Mostrar más ({{remaining}} restantes)`,
      totalCallsTitle: `Total de llamadas`,
      totalMinutesTitle: `Total de minutos`,
    },

    extensionComparisonTable: {
      columns: {
        extension: `Extensión`,
        calls: `Llamadas`,
        percentCalls: `% Total`,
        minutes: `Minutos`,
        percentMinutes: `% Total`,
      },
    },

    extensionMultiDropdown: {
      allExtensions: `Todas las extensiones`,
    },

    extensionPills: {
      extensionsSelected: `{{count}} extensiones seleccionadas`,
    },

    dashboards: {
      noDataAvailable: `No hay datos disponibles`,
      gettingPbx: `Obteniendo PBX...`,
      noStatisticsAvailable: `No hay estadísticas disponibles`,
      noGridData: `No hay datos de cuadrícula`,
      errorLoadingStatistics: `Error al cargar estadísticas`,
      errorLoadingCallData: `Error al cargar datos de llamadas`,
      noCallDataAvailable: `No hay datos de llamadas disponibles`,
      errorLoadingVoicemailData: `Error al cargar datos de correo de voz`,
      noVoicemailDataAvailable: `No hay datos de correo de voz disponibles`,
      csvExport: {
        buttonLabel: `Exportar CSV`,
        exported: `Exportado`,
        success: `CSV exportado`,
        failed: `Error al exportar CSV`,
        headers: {
          inboundAnswerRate: {
            startDateTime: `Fecha/Hora de Inicio`,
            endDateTime: `Fecha/Hora de Fin`,
            answeredCalls: `Llamadas Contestadas`,
            missedCalls: `Llamadas Perdidas`,
            totalCalls: `Total de Llamadas`,
            answerRatePercent: `Tasa de Respuesta %`,
          },
          numberComparison: {
            phoneNumber: `Número de Teléfono`,
            displayNumber: `Número de Visualización`,
            name: `Nombre`,
            inboundCalls: `Llamadas Entrantes`,
            totalDurationSeconds: `Duración Total (segundos)`,
            averageDurationSeconds: `Duración Promedio (segundos)`,
          },
          extensionComparison: {
            extension: `Extensión`,
            totalCalls: `Total de Llamadas`,
            totalMinutes: `Total de Minutos`,
            totalDurationSeconds: `Duración Total (segundos)`,
            averageDurationSeconds: `Duración Promedio (segundos)`,
          },
        },
      },
      unknown: `Desconocido`,
      notAvailable: `N/D`,
    },

    aria: {
      backspace: `Retroceso`,
      toggleColorMode: `Cambiar modo de color`,
    },

    callAnalytics: {
      empty: {
        noTranscriptRecord: `Vaya, no parece haber un registro de transcripción para esta llamada.`,
        noCallSelected: `Ninguna llamada seleccionada`,
      },
      stats: {
        agentTalkTime: `Tiempo de conversación del agente`,
        talking: `Hablando: {{duration}} ({{percent}}%)`,
        listening: `Escuchando: {{duration}} ({{percent}}%)`,
        agentTalkSpeed: `Velocidad de conversación del agente`,
        wordsPerMinute: `{{count}} palabras por minuto (promedio)`,
        holdTimeAndPauses: `Tiempo en espera y pausas`,
        holdPercentOfCall: `{{duration}} ({{percent}}% de la llamada)`,
        interruptionsTotal: `Interrupciones: {{count}} en total`,
        interruptionsAgent: `Agente: {{count}} ({{percent}}%)`,
        interruptionsCustomer: `Cliente: {{count}} ({{percent}}%)`,
      },
      transcript: {
        office: `Oficina`,
        patient: `Paciente`,
        silence: `Silencio {{duration}}`,
      },
    },

    filterModal: {
      header: `Filtros`,
      apply: `Aplicar filtros`,
      clear: `Borrar`,
      clearSection: `Borrar {{title}}`,
      buttonTitle: `Filtros`,
      tooltipOneApplied: `{{title}} ({{count}} filtro aplicado)`,
      tooltipManyApplied: `{{title}} ({{count}} filtros aplicados)`,
    },

    previewModal: {
      rotate: `Rotar`,
      imagePreview: `Vista previa de imagen`,
    },

    pdfViewer: {
      loadError: `No se pudo cargar este archivo`,
    },

    mangoPlusAds: {
      stayRelevant: `Mantente relevante`,
      inTodaysWorld: `en el mundo de hoy`,
      bodyHeading: `¿A quién no le gusta enviar mensajes?`,
      paragraph1: `Hoy en día, la gente prefiere enviar mensajes en lugar de llamar. Elige enviar mensajes a tus clientes: ahorra tiempo y energía.`,
      paragraph2: `Los mensajes son solo uno de los muchos beneficios de Mango Plus. Habla con nuestro equipo de ventas sobre un mes de prueba antes de comprar.`,
      learnMore: `Más información`,
    },

    outboundPhoneSearch: {
      placeholder: `Seleccionar número`,
    },

    faxFilters: {
      directionTooltip: `Filtro de dirección`,
      allFaxes: `Todos los faxes`,
    },

    messagingThread: {
      dropFileToSend: `Suelta el archivo para enviar`,
    },

    resetPassword: {
      togglePasswordVisibility: `Mostrar u ocultar contraseña`,
    },

    resourceErrorBoundary: {
      defaultMessage: `Ocurrió un error inesperado.`,
      notFoundFallback: `Vaya, este registro se eliminó o no existe. Si necesitas ayuda, contacta a soporte.`,
      takeMeBack: `Volver`,
    },

    moveFaxModal: {
      toast: {
        errorMoving: `Ocurrió un error al mover el fax.`,
        notMarkedUnread: `El fax no se marcó como no leído.`,
        moveFailed: `No se pudo mover el fax al fax virtual seleccionado.`,
        errorTitle: `Error al mover el fax`,
      },
      noAccessWarning: `Si no tienes acceso al fax virtual seleccionado, no podrás ver este fax una vez que se haya movido.`,
    },

    filePrinter: {
      printFailed: `No se pudo imprimir el archivo.`,
    },

    router: {
      loadingContent: `Cargando contenido...`,
    },

    resourceFailedToLoad: {
      permission: `No tienes permiso para acceder a este buzón de voicemail`,
      deleted: `Voicemail eliminado`,
      unavailable: `Voicemail no disponible`,
      contactAdmin: `Para obtener acceso, contacta a tu administrador del sistema`,
    },

    tagInput: {
      commaSeparated: `Los valores múltiples deben estar separados por comas`,
      removeTag: `Eliminar {{value}}`,
      valueNotAdded: `No se pudo agregar este valor`,
      valuesNotAdded: `No se pudieron agregar estos valores`,
      invalidValue: `Este valor no es un {{valueType}} válido`,
      invalidValues: `Estos valores no son válidos ({{valueType}})`,
      limitReached: `Se alcanzó el máximo de {{maxTags}}. Elimine uno para agregar otro.`,
      errorAndLimit: `{{error}}. {{limit}}`,
    },

    unsavedChangesDialog: {
      title: `Cambios sin guardar`,
      body: `Tienes cambios sin guardar. ¿Seguro que quieres salir de esta página? Se perderán los cambios.`,
      stay: `Permanecer en la página`,
      discard: `Descartar cambios`,
    },

    blockedNumber: {
      blockNumbers: `Bloquear números`,
    },

    notificationsBanner: {
      grantedPrefix: `Genial, las preferencias de notificación se pueden ajustar en`,
      settings: `ajustes`,
      prompt: `Mango funciona mejor con notificaciones para mantenerte al día.`,
      enable: `¡Activar notificaciones!`,
    },

    switchboardEdit: {
      invalidDialPlan: `Plan de marcado de extensión no válido`,
      invalidPbxId: `ID de PBX no válido`,
      loading: `Cargando centralita...`,
    },

    webPhoneExtras: {
      activeCall: `Llamada activa`,
      failedSearch: `Búsqueda fallida`,
      otherLabel: `otro`,
      awayWithLabel: `Ausente - {{label}}`,
    },

    callDetailsExtras: {
      callInProgress: `Llamada en curso`,
      mayTakeMinutes: `Esto puede tardar varios minutos`,
    },

    contactCombinedCell: {
      fromPrefix: `D:`,
      toPrefix: `A:`,
    },

    messaging:
      messagingEsUs as unknown as (typeof en)['translation']['messaging'],
    phoneNumbers:
      phoneNumbersEsUs as unknown as (typeof en)['translation']['phoneNumbers'],
    pbxLocations:
      pbxLocationsEsUs as unknown as (typeof en)['translation']['pbxLocations'],
    musicOnHold:
      musicOnHoldEsUs as unknown as (typeof en)['translation']['musicOnHold'],
    hotels: hotelsEsUs as unknown as (typeof en)['translation']['hotels'],
    soundClips:
      soundClipsEsUs as unknown as (typeof en)['translation']['soundClips'],
    ...systemSettingsEsUs,
    pbxSettings:
      pbxSettingsEsUs as unknown as (typeof en)['translation']['pbxSettings'],
    devices: devicesEsUs as unknown as (typeof en)['translation']['devices'],
    extensions:
      extensionsEsUs as unknown as (typeof en)['translation']['extensions'],
    userGroups:
      userGroupsEsUs as unknown as (typeof en)['translation']['userGroups'],
    webhooks: webhooksEsUs as unknown as (typeof en)['translation']['webhooks'],
  },
  support_phone_label: `Línea de Soporte: {{phoneNumber, phone}}`,
  user_profile_phone: `Tu número de teléfono registrado es: {{userPhone, phone}}`,
} satisfies typeof en
